<template>
  <div class="animated fadeIn">
    <Row>
      关键字：
      <Input size="small" search @on-search="onFilterClick" v-model="keywordFilter" placeholder="输入关键字" clearable style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onResetAllReportInterval">重置所有上传间隔</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="batchSendCmdModal=true">批量发送指令</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="jt808batchSendcmdModal=true">批量发送快捷指令</Button>
      <!--      <Button size="small" type="primary" style="margin-right: 3px;" @click="jt808SetBatchParameterdataModal=true">批量设置终端参数</Button>-->
    </Row>
    <Row style="margin-top: 3px;">
      <Col :md="24">
        <div style="width: 100%;">
          <!--<Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" show-total @on-change="setPage"-->
          <!--style="text-align:right;margin-top:50px;margin-bottom: 20px;"></Page>-->
          <div style="position:relative;">
            <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
            <Table border highlight-row size="small" height="600" :columns="computeCol" :data="content" ref="table" :height="tableHeight"
                   @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
            <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="list_loadding">
              <Spin size="large"></Spin>
              <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
            </div>
          </div>
          <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
                show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
                style="text-align:right;margin-top:5px"></Page>
        </div>
      </Col>
      <Col :md="12">
      </Col>
    </Row>

    <Modal v-model="showSendCommandModal" width="600" title="发送指令">
      <Form ref="sendCommand" autoComplete="on" v-model="sendCommand"
            class="card-box login-form">
        <Form-item label="指令内容">
          <Input v-model="sendCommand.content" placeholder="指令内容"
                 style="width: 400px;"></Input>
        </Form-item>
        <Checkbox v-model="sendCommand.urgent">紧急</Checkbox>
        <Button type="primary" @click="onSendCommand">发送</Button>
      </Form>
    </Modal>

    <Modal v-model="showSetupRegistrationNoModal" width="600" title="发送指令">
      <Form ref="setupRegistration" autoComplete="on" v-model="setupRegistration"
            class="card-box login-form">

        <Form-item label="车牌号码">
          <Input v-model="setupRegistration.registrationNum" placeholder="车牌号码"
                 style="width: 100px;"></Input>
        </Form-item>

        <Form-item label="车牌颜色">
          <Select v-model="setupRegistration.registrationColor">
            <Option value=1 key=1>蓝色</Option>
            <Option value=2 key=2>黄色</Option>
            <Option value=3 key=3>黑色</Option>
            <Option value=4 key=4>白色</Option>
            <Option value=5 key=5>渐变绿色</Option>
            <Option value=5 key=5>黄绿色</Option>
          </Select>
        </Form-item>

        <Button type="primary" @click="onSetupRegistration">发送</Button>
      </Form>
    </Modal>

    <Modal v-model="batchSendCmdModal" width="600" title="批量发送指令">
      <Form ref="setupRegistrationNo" autoComplete="on" v-model="setupRegistrationNo"
            class="card-box login-form">
        <Form-item label="生产厂商">
          <Select v-model="batchManufacturer" @on-change="getManufacturer">
            <Option value='请选择' key=0>请选择</Option>
            <Option value='惠州博实结科技有限公司' key=1>惠州博实结科技有限公司</Option>
            <Option value='杭州海康汽车技术有限公司' key=2>杭州海康汽车技术有限公司</Option>
            <Option value='易流' key=3>易流</Option>
            <Option value='有为' key=4>有为</Option>
            <Option value='深圳市锐明技术股份有限公司' key=5>深圳市锐明技术股份有限公司</Option>
            <Option value='江苏中天安驰科技有限公司' key=6>江苏中天安驰科技有限公司</Option>
          </Select>
        </Form-item>
        <Form-item label="主机号列表">
          <Input type="textarea" v-model="terminalNums" placeholder="主机号列表，使用','分隔"></Input>
        </Form-item>
        <Form-item label="指令">
          <Dropdown style="margin-right: 5px;">
            <Button type="primary">
              博实结
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="BSJ_Collect">采集车辆信息</DropdownItem>
              <!--              <DropdownItem>设置车牌</DropdownItem>-->
              <!--              <DropdownItem>设置里程</DropdownItem>-->
              <!--              <DropdownItem>设置车辆参数</DropdownItem>-->
            </DropdownMenu>
          </Dropdown>
          <Dropdown style="margin-right: 5px;">
            <Button type="primary">
              海康
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <!--              <DropdownItem>采集信息</DropdownItem>-->
              <!--              <DropdownItem>写卡</DropdownItem>-->
              <!--              <DropdownItem>设置车牌号</DropdownItem>-->
              <!--              <DropdownItem>设置车辆参数</DropdownItem>-->
              <DropdownItem @click.native="hikTravelTimeModal = true">设置夜间行驶时长</DropdownItem>
              <!--              <DropdownItem>采集设备信息</DropdownItem>-->
              <!--              <DropdownItem>获取设备报警</DropdownItem>-->
            </DropdownMenu>
          </Dropdown>
          <Dropdown style="margin-right: 5px;">
            <Button type="primary">
              锐明
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <!--              <DropdownItem>采集信息</DropdownItem>-->
              <!--              <DropdownItem>写卡</DropdownItem>-->
              <!--              <DropdownItem>设置车辆参数</DropdownItem>-->
              <!--              <DropdownItem>设置参数</DropdownItem>-->
              <DropdownItem @click.native="rmDriverModal = true">设置协议</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Dropdown style="margin-right: 5px;">
            <Button type="primary">
              中天
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <!--              <DropdownItem>采集信息</DropdownItem>-->
              <!--              <DropdownItem>写卡</DropdownItem>-->
              <!--              <DropdownItem>设置车辆参数</DropdownItem>-->
              <DropdownItem @click.native="ztDriverSpeedAlarmModal = true">设置速度报警</DropdownItem>
              <!--              <DropdownItem>设置里程</DropdownItem>-->
              <DropdownItem @click.native="ztDriverRestartModal = true">重启控制</DropdownItem>
              <!--              <DropdownItem>磁盘格式化</DropdownItem>-->
              <DropdownItem @click.native="ztDriverAdasAlarmModal = true">ADAS报警</DropdownItem>
              <DropdownItem @click.native="ztDriverDsmAlarmModal = true">DSM报警</DropdownItem>
              <DropdownItem @click.native="ztDriverAlarmEnablelModal = true">报警使能</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Form-item>
        <Form-item label="指令内容">
          <Input v-model="batchSendCmd.cmd" placeholder="指令内容"></Input>
        </Form-item>
        <Form-item>
          <Checkbox v-model="batchSendCmd.urgent">紧急</Checkbox>
          <Button type="primary" @click="onBatchSendCmd">发送</Button>
        </Form-item>
        <Form-item>
          <Checkbox v-model="batchSendCmd.settime" @on-change="onsettimeBatchSendCmd">定时发送</Checkbox>
          <Input style="display: inline-block; width: 160px;" v-model="batchSendCmd.time"
                 placeholder="发送时间：（单位：秒）"></Input>
        </Form-item>
      </Form>
    </Modal>

    <Modal v-model="setupVehicleParamsModal" width="600" title="设置车辆参数" @on-visible-change="visibleChange">
      <Form ref="setupVehicleParams" autoComplete="on" v-model="setupVehicleParams"
            class="card-box login-form">
        <FormItem>
          <label>注：如不修改的字段请留空</label>
        </FormItem>
        <FormItem prop="driverCardNum">
          <label style="display: inline-block; width: 100px;">司机卡号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverCardNum"
                 placeholder="请输入司机卡号">
          </Input>
        </FormItem>
        <FormItem prop="driverLicenseNum">
          <label style="display: inline-block; width: 100px;">驾驶证号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverLicenseNum"
                 placeholder="请输入驾驶证号">
          </Input>
        </FormItem>
        <FormItem prop="driverName">
          <label style="display: inline-block; width: 100px;">驾驶员名</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverName"
                 placeholder="请输入驾驶员名">
          </Input>
        </FormItem>
        <FormItem prop="vin">
          <label style="display: inline-block; width: 100px;">车架号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.vin" placeholder="请输入车架号">
          </Input>
        </FormItem>
        <FormItem prop="registrationNum">
          <label style="display: inline-block; width: 100px;">车牌号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.registrationNum"
                 placeholder="请输入车牌号">
          </Input>
        </FormItem>
        <FormItem prop="vehicleTypeName">
          <label style="display: inline-block; width: 100px;">车牌分类</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.vehicleTypeName"
                 placeholder="请输入车牌分类">
          </Input>
        </FormItem>
        <FormItem prop="engineNum">
          <label style="display: inline-block; width: 100px;">发动机号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.engineNum"
                 placeholder="请输入发动机号">
          </Input>
        </FormItem>
        <FormItem prop="organizationNames">
          <label style="display: inline-block; width: 100px;">发证机构</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.organizationNames"
                 placeholder="请输入发证机构">
          </Input>
        </FormItem>
        <FormItem prop="indate" label="证件有效期">
          <DatePicker style="display: inline-block; width: 200px;" type="date" v-model="setupVehicleParams.indate"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
        <Button type="primary" @click="onCleanVehicleParams" style="margin-right: 5px;">清空</Button>
        <Button type="primary" @click="onSetupVehicleParams">发送</Button>
      </Form>
    </Modal>

    <Modal v-model="setupReportIntervalModal" width="600" title="汇报间隔">
      <Form ref="setupReportInterval" autoComplete="on" v-model="setupReportInterval"
            class="card-box login-form">
        <FormItem prop="driverCardNum">
          <label style="display: inline-block; width: 100px;">ACC开上传间隔</label>
          <InputNumber :min="0" :step="1" style="display: inline-block; width: 200px;"
                       v-model="setupReportInterval.accOn" placeholder="请输入ACC开上传间隔">
          </InputNumber>
        </FormItem>
        <FormItem prop="driverLicenseNum">
          <label style="display: inline-block; width: 100px;">ACC关上传间隔</label>
          <InputNumber :min="0" :step="1" style="display: inline-block; width: 200px;"
                       v-model="setupReportInterval.accOff" placeholder="请输入ACC关上传间隔">
          </InputNumber>
        </FormItem>
        <Button type="primary" @click="onSetupReportInterval">发送</Button>
      </Form>
    </Modal>

    <!--  行驶记录数据采集命令  -->
    <Modal
      v-model="drivingRecorderDataUploadChange"
      width="500"
      title="行驶记录数据采集命令"
      @on-ok="onSendDrivingRecorderDataUploadChange"
      ok-text="发送">
      <Form ref="loginForm" :model="drivingRecorderDataUpload">
        <FormItem prop="code">
          <label style="display: inline-block; width: 100px;">采集命令字</label>
          <Select v-model="drivingRecorderDataUpload.command">
            <Option value=1 key=1>当前驾驶人信息</Option>
            <!--            <Option value=2 key=2>记录仪实时时间</Option>-->
            <!--            <Option value=3 key=3>累计行驶里程</Option>-->
            <!--            <Option value=4 key=4>记录仪脉冲系数</Option>-->
            <Option value=5 key=5>车辆信息</Option>
          </Select>
        </FormItem>
        <!--        <FormItem prop="code">-->
        <!--          <Checkbox v-model="drivingRecorderDataUpload.after2019">是否2019协议</Checkbox>-->
        <!--        </FormItem>-->
        <FormItem prop="buttons">
          <Button size="small" type="primary" @click="onSendDrivingRecorderDataUploadChange">发送</Button>
        </FormItem>
      </Form>
    </Modal>
    <!-- 海康，透传获取设备信息 -->
    <Modal
      v-model="dataDownlinkTransmissionChange"
      width="500"
      title="透传获取设备信息"
      @on-ok="onSendHIKHardDisk"
      ok-text="发送">
      <Form ref="loginForm" :model="dataDownlinkTransmission">
        <FormItem prop="code">
          <label style="display: inline-block; width: 100px;">透传通道</label>
          <Select v-model="transDataType">
            <Option value=247 key=247>透传获取设备状态</Option>
          </Select>
        </FormItem>
        <!--            <FormItem prop="hex">-->
        <!--              <label style="display: inline-block; width: 100px;">数据格式</label>-->
        <!--              <Select v-model="ishex">-->
        <!--                <Option value=0 key=0>文本</Option>-->
        <!--                <Option value=1 key=1>HEX</Option>-->
        <!--              </Select>-->
        <!--            </FormItem>-->
        <FormItem prop="content">
          <label style="display: inline-block; width: 200px;">内容格式</label>
          <Input type="textarea" v-model="dataDownlinkTransmission.content" placeholder="内容格式"></Input>
          <Select v-model="datacontent">
            <Option value=1 key=1>无</Option>
            <Option value=64 key=64>高级驾驶辅助系统</Option>
            <Option value=65 key=65>驾驶员状态监控系统</Option>
            <Option value=66 key=66>轮胎气压监测系统</Option>
            <Option value=67 key=67>盲点监测系统</Option>
          </Select>
        </FormItem>
        <FormItem prop="buttons">
          <Button size="small" type="primary" @click="onSendHIKHardDisk">发送</Button>
        </FormItem>
      </Form>
    </Modal>

    <setup-bsj-mileage-modal v-model="setupBsjMileageModal" :initValue="setupBsjMileageId"></setup-bsj-mileage-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
    <jt1078-cmd-modal v-model="jt1078CmdModal" :initValue="jt1078CmdId"></jt1078-cmd-modal>
    <data-downlink-transmission-modal v-model="dataDownlinkTransmissionModal" :initValue="dataDownlinkTransmissionId"></data-downlink-transmission-modal>
    <bsj-set-max-speed-modal v-model="BsjSetMaxSpeedModal" :initValue="BsjSetMaxSpeedId"></bsj-set-max-speed-modal>
    <bsj-set-g-f-viewing-screen-modal v-model="bsjSetGFViewingScreenModal" :initValue="bsjSetGFViewingScreenId"></bsj-set-g-f-viewing-screen-modal>
    <bsj-set-driver-detection-modal v-model="bsjSetDriverDetectionModal" :initValue="bsjSetDriverDetectionId"></bsj-set-driver-detection-modal>
    <bsj-set-trigger-alarm-modal v-model="bsjSetTriggerAlarmModal" :initValue="bsjSetTriggerAlarmId"></bsj-set-trigger-alarm-modal>
    <hik-set-driver-card-modal v-model="hikSetDriverCardModal" :initValue="hikSetDriverCardId" :terminalNumValue="hikSetDriverCardterminalNum"></hik-set-driver-card-modal>
    <hik-set-driver-vehicleinfo-modal v-model="hikSetDriverVehicleinfoModal" :initValue="hikSetDriverVehicleinfoId" :terminalNumValue="hikSetDriverVehicleinfoterminalNum"></hik-set-driver-vehicleinfo-modal>
    <hik-set-driver-vehicleinfo-registrationnum-modal v-model="hikSetDriverVehicleinfoRegistrationnumModal" :initValue="hikSetDriverVehicleinfoRegistrationnumId"></hik-set-driver-vehicleinfo-registrationnum-modal>
    <hik-set-mileage-modal v-model="HikSetMileageModal" :initValue="HikSetMileageId"></hik-set-mileage-modal>
    <!--    <hik-set-alarm-modal v-model="hikSetAlarmModalId" :initValue="hikSetAlarmModalId"></hik-set-alarm-modal>-->
    <hik-set-trigger-alarm-modal v-model="hikSetTriggerAlarmModalModal" :initValue="hikSetTriggerAlarmModalId"></hik-set-trigger-alarm-modal>
    <hik-set-travel-time-modal v-model="hikSetTravelTimeModal" :initValue="hikSetTravelTimeId"></hik-set-travel-time-modal>
    <hik-travel-time-modal v-model="hikTravelTimeModal" :initValue="hikTravelTimeId" @HIK_TravelTime="HIK_TravelTime"></hik-travel-time-modal>
    <hik-set-driver-card-institution-modal v-model="hikSetDriverCardInstitutionModal" :initValue="hikSetDriverCardInstitutionId" ></hik-set-driver-card-institution-modal>
    <jt808-set-fatigue-driving-alarm-difference-modal v-model="jt808SetFatigueDrivingAlarmDifferenceModal" :initValue="jt808SetFatigueDrivingAlarmDifferenceId"></jt808-set-fatigue-driving-alarm-difference-modal>
    <jt808-set-continue-drive-limit-modal v-model="jt808SetContinueDriveLimitModal" :initValue="jt808SetContinueDriveLimitId"></jt808-set-continue-drive-limit-modal>
    <jt808-set-continue-drive-limit-per-day-modal v-model="jt808SetContinueDriveLimitPerDayModal" :initValue="jt808SetContinueDriveLimitPerDayId"></jt808-set-continue-drive-limit-per-day-modal>
    <jt808-set-max-speed-modal v-model="jt808SetMaxSpeedModal" :initValue="jt808SetMaxSpeedId"></jt808-set-max-speed-modal>
    <jt808-set-max-stop-time-modal v-model="jt808SetMaxStopTimeModal" :initValue="jt808SetMaxStopTimeId"></jt808-set-max-stop-time-modal>
    <jt808-set-min-resting-time-modal v-model="jt808SetMinRestingTimeModal" :initValue="jt808SetMinRestingTimeId"></jt808-set-min-resting-time-modal>
    <jt808-set-over-speed-duration-modal v-model="jt808SetOverSpeedDurationModal" :initValue="jt808SetOverSpeedDurationId"></jt808-set-over-speed-duration-modal>
    <jt808-set-over-speed-alarm-difference-modal v-model="jt808SetOverSpeedAlarmDifferenceModal" :initValue="jt808SetOverSpeedAlarmDifferenceId"></jt808-set-over-speed-alarm-difference-modal>
    <jt808-set-all-report-interval-modal v-model="jt808SetAllReportIntervalModal"></jt808-set-all-report-interval-modal>
    <jt808-set-parameterdata-modal v-model="jt808SetParameterdataModal" :initValue="jt808SetParameterdataId" :initData="jt808SetParameterdata"></jt808-set-parameterdata-modal>
    <jt808-set-batch-parameterdata-modal v-model="jt808SetBatchParameterdataModal"></jt808-set-batch-parameterdata-modal>
    <jt808-monitoring-view-modal ref="Jt808MonitoringViewModalRef" v-model="jt808MonitoringViewModal" :initValue="jt808MonitoringViewId" :jt808MonitoringViewterminalNum="jt808MonitoringViewterminalNum"></jt808-monitoring-view-modal>
    <batch-sendcmd-modal  v-model="jt808batchSendcmdModal"></batch-sendcmd-modal>
    <rm-set-travel-time-modal v-model="rmSetTravelTimeModal" :initValue="rmSetTravelTimeId" :terminalNumValue="rmSetTravelTimeterminalNum"></rm-set-travel-time-modal>
    <rm-set-driver-vehicleinfo-modal v-model="rmSetDriverVehicleinfoModal" :initValue="rmSetDriverVehicleinfoId" :terminalNumValue="rmSetDriverVehicleinfoterminalNum"></rm-set-driver-vehicleinfo-modal>
    <rm-query-parameters-modal v-model="rmQueryParametersModal" :initValue="rmQueryParametersId"></rm-query-parameters-modal>
    <rm-set-driver-parameters-modal v-model="rmSetDriverParametersModal" :initValue="rmSetDriverParametersId"></rm-set-driver-parameters-modal>
    <rm-set-driver-modal v-model="rmSetDriverModal" :initValue="rmSetDriverId"></rm-set-driver-modal>
    <rm-driver-modal v-model="rmDriverModal" :initValue="rmDriverId" @RM_Driver="RM_Driver"></rm-driver-modal>
    <rm-set-driver-i-p-modal v-model="rmSetDriverIPModal"  :initValue="rmSetDriverIPId"></rm-set-driver-i-p-modal>
    <rm-set-driver-alarm-condition-modal v-model="rmSetDriverAlarmConditionModal"  :initValue="rmSetDriverAlarmConditionId"></rm-set-driver-alarm-condition-modal>
    <rm-set-upload-interval-modal v-model="rmSetUploadIntervalModal"  :initValue="rmSetUploadIntervalId"></rm-set-upload-interval-modal>
    <rm-set-trigger-alarm-modal v-model="rmSetTriggerAlarmModal" :initValue="rmSetTriggerAlarmId"></rm-set-trigger-alarm-modal>
    <rm-set-close-s-i-m-lock-modal v-model="rmSetCloseSIMLockModal" :initValue="rmSetCloseSIMLockId"></rm-set-close-s-i-m-lock-modal>
    <zt-set-driver-card-modal v-model="ztSetDriverCardModal" :initValue="ztSetDriverCardId" :terminalNumValue="ztSetDriverCardterminalNum"></zt-set-driver-card-modal>
    <zt-set-driver-vehicleinfo-modal v-model="ztSetDriverVehicleinfoModal" :initValue="ztSetDriverVehicleinfoId" :terminalNumValue="ztSetDriverVehicleinfoterminalNum"></zt-set-driver-vehicleinfo-modal>
    <zt-set-driver-speed-alarm-modal v-model="ztSetDriverSpeedAlarmModal" :initValue="ztSetDriverSpeedAlarmId"></zt-set-driver-speed-alarm-modal>
    <zt-driver-speed-alarm-modal v-model="ztDriverSpeedAlarmModal" :initValue="ztDriverSpeedAlarmId" @ZT_DriverSpeedAlarm="ZT_DriverSpeedAlarm"></zt-driver-speed-alarm-modal>
    <zt-set-disk-formatting-modal v-model="ztSetDiskFormattingModal" :initValue="ztSetDiskFormattingId"></zt-set-disk-formatting-modal>
    <zt-set-driver-mileage-modal v-model="ztSetDriverMileageModal" :initValue="ztSetDriverMileageId"></zt-set-driver-mileage-modal>
    <zt-set-driver-restart-modal v-model="ztSetDriverRestartModal" :initValue="ztSetDriverRestartId"></zt-set-driver-restart-modal>
    <zt-driver-restart-modal v-model="ztDriverRestartModal" :initValue="ztDriverRestartId" @ZT_DriverRestart="ZT_DriverRestart"></zt-driver-restart-modal>
    <zt-set-driver-centernetwork-modal v-model="ztSetDriverCenternetworkModal" :initValue="ztSetDriverCenternetworkId" ></zt-set-driver-centernetwork-modal>
    <zt-set-driver-adas-alarm-modal v-model="ztSetDriverAdasAlarmModal" :initValue="ztSetDriverAdasAlarmId"></zt-set-driver-adas-alarm-modal>
    <zt-driver-adas-alarm-modal v-model="ztDriverAdasAlarmModal" :initValue="ztDriverAdasAlarmId" @ZT_DriverAdasAlarm="ZT_DriverAdasAlarm"></zt-driver-adas-alarm-modal>
    <zt-set-driver-dsm-alarm-modal v-model="ztSetDriverDsmAlarmModal" :initValue="ztSetDriverDsmAlarmId"></zt-set-driver-dsm-alarm-modal>
    <zt-driver-dsm-alarm-modal v-model="ztDriverDsmAlarmModal" :initValue="ztDriverDsmAlarmId" @ZT_DriverDsmAlarm="ZT_DriverDsmAlarm"></zt-driver-dsm-alarm-modal>
    <zt-set-driver-alarm-enablel-modal v-model="ztSetDriverAlarmEnablelModal" :initValue="ztSetDriverAlarmEnablelId"></zt-set-driver-alarm-enablel-modal>
    <zt-set-test-pattern-modal v-model="ztSetTestPatternModal" :initValue="ztSetTestPatternId"></zt-set-test-pattern-modal>
    <zt-set-trigger-alarm-modal v-model="ztSetTriggerAlarmModal" :initValue="ztSetTriggerAlarmId"></zt-set-trigger-alarm-modal>
    <zt-driver-alarm-enablel-modal v-model="ztDriverAlarmEnablelModal" :initValue="ztDriverAlarmEnablelId" @ZT_DriverAlarmEnablel="ZT_DriverAlarmEnablel"></zt-driver-alarm-enablel-modal>
    <tl-set-driver-card-modal v-model="tlSetDriverCardModal" :initValue="tlSetDriverCardId" :terminalNumValue="tlSetDriverCardterminalNum"></tl-set-driver-card-modal>
    <tl-set-driver-vehicleinfo-modal v-model="tlSetDriverVehicleinfoModal" :initValue="tlSetDriverVehicleinfoId" :terminalNumValue="tlSetDriverVehicleinfoterminalNum"></tl-set-driver-vehicleinfo-modal>
    <tl-set-hard-disk-slarm-modal v-model="tlSetHardDiskSlarmModal" :initValue="tlSetHardDiskSlarmId" :terminalNumValue="tlSetHardDiskSlarmterminalNum"></tl-set-hard-disk-slarm-modal>
    <tl-set-trigger-alarm-modal v-model="tlSetTriggerAlarmModal" :initValue="tlSetTriggerAlarmId"></tl-set-trigger-alarm-modal>
    <sh-set-driver-card-modal v-model="shSetDriverCardModal" :initValue="shSetDriverCardId" :terminalNumValue="shSetDriverCardterminalNum"></sh-set-driver-card-modal>
    <sh-set-driver-vehicleinfo-modal v-model="shSetDriverVehicleinfoModal" :initValue="shSetDriverVehicleinfoId" :terminalNumValue="shSetDriverVehicleinfoterminalNum"></sh-set-driver-vehicleinfo-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>

  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import Cookies from 'js-cookie'
import SetupBsjMileageModal from '@/view/ddm/components/setup-bsj-mileage-modal'
import Jt1078CmdModal from '@/view/ddm/components/jt1078-cmd-modal'
import DataDownlinkTransmissionModal from '@/view/ddm/components/data-downlink-transmission-modal'
import BsjSetMaxSpeedModal from '@/view/ddm/components/bsj-set-max-speed-modal'
import BsjSetGFViewingScreenModal from '@/view/ddm/components/bsj-set-GF-viewing-screen-modal'
import BsjSetDriverDetectionModal from '@/view/ddm/components/bsj-set-driver-detection-modal'
import BsjSetTriggerAlarmModal from '@/view/ddm/components/bsj-set-trigger-alarm-modal'
import HikSetDriverCardModal from '@/view/ddm/components/hik-set-driver-card-modal'
import HikSetDriverVehicleinfoModal from '@/view/ddm/components/hik-set-driver-vehicleinfo-modal'
import HikSetDriverVehicleinfoRegistrationnumModal from '@/view/ddm/components/hik-set-driver-vehicleinfo-registrationnum-modal'
import HikSetMileageModal from '@/view/ddm/components/hik-set-mileage-modal'
// import HikSetAlarmModal from '@/view/ddm/components/hik-set-alarm-modal'
import HikSetTriggerAlarmModal from '@/view/ddm/components/hik-set-trigger-alarm-modal'
import HikSetTravelTimeModal from '@/view/ddm/components/hik-set-travel-time-modal'
import HikTravelTimeModal from '@/view/ddm/components/hik-travel-time-modal'
import HikSetDriverCardInstitutionModal from '@/view/ddm/components/hik-set-driver-card-institution-modal'
import ZtSetDriverCardModal from '@/view/ddm/components/zt-set-driver-card-modal'
import ZtSetDriverVehicleinfoModal from '@/view/ddm/components/zt-set-driver-vehicleinfo-modal'
import ZtSetDriverSpeedAlarmModal from '@/view/ddm/components/zt-set-driver-speed-alarm-modal'
import ZtDriverSpeedAlarmModal from '@/view/ddm/components/zt-driver-speed-alarm-modal'
import ZtSetDiskFormattingModal from '@/view/ddm/components/zt-set-disk-formatting-modal'
import ZtSetDriverMileageModal from '@/view/ddm/components/zt-set-driver-mileage-modal'
import ZtSetDriverRestartModal from '@/view/ddm/components/zt-set-driver-restart-modal'
import ZtDriverRestartModal from '@/view/ddm/components/zt-driver-restart-modal'
import ZtSetDriverCenternetworkModal from '@/view/ddm/components/zt-set-driver-centernetwork-modal'
import ZtSetDriverAdasAlarmModal from '@/view/ddm/components/zt-set-driver-adas-alarm-modal'
import ZtDriverAdasAlarmModal from '@/view/ddm/components/zt-driver-adas-alarm-modal'
import ZtSetDriverDsmAlarmModal from '@/view/ddm/components/zt-set-driver-dsm-alarm-modal'
import ZtDriverDsmAlarmModal from '@/view/ddm/components/zt-driver-dsm-alarm-modal'
import ZtSetDriverAlarmEnablelModal from '@/view/ddm/components/zt-set-driver-alarm-enablel-modal'
import ZtDriverAlarmEnablelModal from '@/view/ddm/components/zt-driver-alarm-enablel-modal'
import ZtSetTestPatternModal from '@/view/ddm/components/zt-set-test-pattern-modal'
import ZtSetTriggerAlarmModal from '@/view/ddm/components/zt-set-trigger-alarm-modal'
import { VehicleDymaicManager } from '@/libs/vehicle-dymaic-manager2'

import RmSetTravelTimeModal from '@/view/ddm/components/rm-set-driver-card-modal'
import RmSetDriverVehicleinfoModal from '@/view/ddm/components/rm-set-driver-vehicleinfo-modal'
import RmQueryParametersModal from '@/view/ddm/components/rm-query-parameters-modal'
import RmSetDriverParametersModal from '@/view/ddm/components/rm-set-driver-parameters-modal'
import RmSetDriverModal from '@/view/ddm/components/rm-set-driver-modal'
import RmDriverModal from '@/view/ddm/components/rm-driver-modal'
import RmSetDriverIPModal from '@/view/ddm/components/rm-set-driver-ip-modal'
import RmSetDriverAlarmConditionModal from '@/view/ddm/components/rm-set-driver-alarm-condition-modal'
import RmSetUploadIntervalModal from '@/view/ddm/components/rm-set-upload-interval-modal'
import RmSetTriggerAlarmModal from '@/view/ddm/components/rm-set-trigger-alarm-modal'
import RmSetCloseSIMLockModal from '@/view/ddm/components/rm-set-close-SIM-lock-modal'
import TlSetDriverCardModal from '@/view/ddm/components/tl-set-driver-card-modal'
import TlSetDriverVehicleinfoModal from '@/view/ddm/components/tl-set-driver-vehicleinfo-modal'
import TlSetHardDiskSlarmModal from '@/view/ddm/components/tl-set-hard-disk-alarm-modal'
import TlSetTriggerAlarmModal from '@/view/ddm/components/tl-set-trigger-alarm-modal'
import ShSetDriverCardModal from '@/view/ddm/components/sh-set-driver-card-modal'
import ShSetDriverVehicleinfoModal from '@/view/ddm/components/sh-set-driver-vehicleinfo-modal'

import Jt808SetFatigueDrivingAlarmDifferenceModal from '@/view/ddm/components/jt808-set-fatigue-driving-alarm-difference-modal'
import Jt808SetContinueDriveLimitModal from '@/view/ddm/components/jt808-set-continue-drive-limit-modal'
import Jt808SetContinueDriveLimitPerDayModal from '@/view/ddm/components/jt808-set-continue-drive-limit-per-day-modal'
import Jt808SetMaxSpeedModal from '@/view/ddm/components/jt808-set-max-speed-modal'
import Jt808SetMaxStopTimeModal from '@/view/ddm/components/jt808-set-max-stop-time-modal'
import Jt808SetMinRestingTimeModal from '@/view/ddm/components/jt808-set-min-resting-time-modal'
import Jt808SetOverSpeedDurationModal from '@/view/ddm/components/jt808-set-over-speed-duration-modal'
import Jt808SetOverSpeedAlarmDifferenceModal from '@/view/ddm/components/jt808-set-over-speed-alarm-difference-modal'
import Jt808SetAllReportIntervalModal from '@/view/ddm/components/jt808-set-all-report-interval-modal'
import Jt808SetParameterdataModal from '@/view/ddm/components/jt808-set-parameterdata-modal'
import Jt808SetBatchParameterdataModal from '@/view/ddm/components/jt808-set-batch-parameterdata-modal'
import Jt808MonitoringViewModal from '@/view/ddm/components/jt808-monitoring-view-modal'
import BatchSendcmdModal from '@/view/ddm/components/batch-send-cmd-modal'

import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'

function getWordsCount (val) {
  var bytesCount = 0
  for (var i = 0; i < val.length; i++) {
    var c = val.charAt(i)
    if (/^[\u0000-\u00ff]$/.test(c)) // 匹配双字节
    {
      bytesCount += 1
    } else {
      bytesCount += 2
    }
  }
  return bytesCount
}

export default {
  name: 'jt808devices',
  components: {
    SetupBsjMileageModal,
    Jt1078CmdModal,
    DataDownlinkTransmissionModal,
    BsjSetMaxSpeedModal,
    BsjSetGFViewingScreenModal,
    BsjSetDriverDetectionModal,
    BsjSetTriggerAlarmModal,
    HikSetDriverCardModal,
    HikSetDriverVehicleinfoModal,
    HikSetDriverVehicleinfoRegistrationnumModal,
    HikSetMileageModal,
    // HikSetAlarmModal,
    HikSetTriggerAlarmModal,
    HikSetTravelTimeModal,
    HikTravelTimeModal,
    HikSetDriverCardInstitutionModal,
    Jt808SetFatigueDrivingAlarmDifferenceModal,
    Jt808SetContinueDriveLimitModal,
    Jt808SetContinueDriveLimitPerDayModal,
    Jt808SetMaxSpeedModal,
    Jt808SetMaxStopTimeModal,
    Jt808SetMinRestingTimeModal,
    Jt808SetOverSpeedDurationModal,
    Jt808SetOverSpeedAlarmDifferenceModal,
    Jt808SetAllReportIntervalModal,
    Jt808SetParameterdataModal,
    Jt808SetBatchParameterdataModal,
    Jt808MonitoringViewModal,
    BatchSendcmdModal,
    RmSetTravelTimeModal,
    RmSetDriverVehicleinfoModal,
    RmQueryParametersModal,
    RmSetDriverParametersModal,
    RmSetDriverModal,
    RmDriverModal,
    RmSetDriverIPModal,
    RmSetDriverAlarmConditionModal,
    RmSetUploadIntervalModal,
    RmSetTriggerAlarmModal,
    RmSetCloseSIMLockModal,
    ZtSetDriverCardModal,
    ZtSetDriverVehicleinfoModal,
    ZtSetDriverSpeedAlarmModal,
    ZtDriverSpeedAlarmModal,
    ZtSetDiskFormattingModal,
    ZtSetDriverMileageModal,
    ZtSetDriverRestartModal,
    ZtDriverRestartModal,
    ZtSetDriverCenternetworkModal,
    ZtSetDriverAdasAlarmModal,
    ZtDriverAdasAlarmModal,
    ZtSetDriverDsmAlarmModal,
    ZtDriverDsmAlarmModal,
    ZtSetDriverAlarmEnablelModal,
    ZtDriverAlarmEnablelModal,
    ZtSetTestPatternModal,
    ZtSetTriggerAlarmModal,
    TlSetDriverCardModal,
    TlSetDriverVehicleinfoModal,
    TlSetHardDiskSlarmModal,
    TlSetTriggerAlarmModal,
    ShSetDriverCardModal,
    ShSetDriverVehicleinfoModal,
    VehicleInfoDetailModal
  },
  data () {
    return {
      gpsEnableFilter: null,
      galileoEnableFilter: null,
      glonassEnableFilter: null,
      beidouEnableFilter: null,

      // websocket连接
      vehicleDymaicManager: null,

      // 实时监控组件
      jt808MonitoringViewModal: false,
      jt808MonitoringViewId: null,
      jt808MonitoringViewterminalNum: null,

      // 设置所有设备汇报间隔
      jt808SetAllReportIntervalModal: false,

      // 设置超速报警预警差值
      jt808SetOverSpeedAlarmDifferenceModal: false,
      jt808SetOverSpeedAlarmDifferenceId: null,

      // 设置超速持续时间
      jt808SetOverSpeedDurationModal: false,
      jt808SetOverSpeedDurationId: null,

      // 设置最小休息时间
      jt808SetMinRestingTimeModal: false,
      jt808SetMinRestingTimeId: null,

      // 设置最长停车时间
      jt808SetMaxStopTimeModal: false,
      jt808SetMaxStopTimeId: null,

      // 设置最高速度
      jt808SetMaxSpeedModal: false,
      jt808SetMaxSpeedId: null,

      // 设置当天累计驾驶时间门限
      jt808SetContinueDriveLimitPerDayModal: false,
      jt808SetContinueDriveLimitPerDayId: null,

      // 设置连续驾驶时间门限
      jt808SetContinueDriveLimitModal: false,
      jt808SetContinueDriveLimitId: null,

      // 设置疲劳驾驶预警差值
      jt808SetFatigueDrivingAlarmDifferenceModal: false,
      jt808SetFatigueDrivingAlarmDifferenceId: null,

      // 设置限速阀值
      BsjSetMaxSpeedModal: false,
      BsjSetMaxSpeedId: null,

      // 设置倒车大屏
      bsjSetGFViewingScreenModal: false,
      bsjSetGFViewingScreenId: null,

      //  关闭驾驶员检测
      bsjSetDriverDetectionModal: false,
      bsjSetDriverDetectionId: null,

      //  bsj触发设备报警
      bsjSetTriggerAlarmModal: false,
      bsjSetTriggerAlarmId: null,

      // Hik设置司机卡
      hikSetDriverCardModal: false,
      hikSetDriverCardId: null,
      hikSetDriverCardterminalNum: null,

      // Hik设置车辆参数
      hikSetDriverVehicleinfoModal: false,
      hikSetDriverVehicleinfoId: null,
      hikSetDriverVehicleinfoterminalNum: null,

      // Hik设置车牌号
      hikSetDriverVehicleinfoRegistrationnumModal: false,
      hikSetDriverVehicleinfoRegistrationnumId: null,

      // Hik设置行驶里程
      HikSetMileageModal: false,
      HikSetMileageId: null,

      // //Hik设置设备报警
      // hikSetAlarmModalModal:false,
      // hikSetAlarmModalId:null,

      // Hik触发设备报警
      hikSetTriggerAlarmModalModal: false,
      hikSetTriggerAlarmModalId: null,

      // Hik设置设置夜间行驶时长
      hikSetTravelTimeModal: false,
      hikSetTravelTimeId: null,

      // Hik批量设置设置夜间行驶时长
      hikTravelTimeModal: false,
      hikTravelTimeId: null,

      // Hik设置发卡机构
      hikSetDriverCardInstitutionModal: false,
      hikSetDriverCardInstitutionId: null,

      drivingRecorderDataUploadChange: false,
      drivingRecorderDataUpload: {
        id: null,
        command: null,
        after2019: null
      },

      dataDownlinkTransmissionChange: false,
      transDataType: 0,
      ishex: 0,
      datacontent: null,
      dataDownlinkTransmission: {
        id: null,
        transDataType: null,
        hex: null,
        content: null
      },

      // 锐明写卡
      rmSetTravelTimeModal: false,
      rmSetTravelTimeId: null,
      rmSetTravelTimeterminalNum: null,

      // 锐明设置车辆参数
      rmSetDriverVehicleinfoModal: false,
      rmSetDriverVehicleinfoId: null,
      rmSetDriverVehicleinfoterminalNum: null,

      // 锐明设置参数
      rmSetDriverParametersModal: false,
      rmSetDriverParametersId: null,

      // 锐明设置车辆协议
      rmSetDriverModal: false,
      rmSetDriverId: null,

      // 锐明批量设置车辆协议
      rmDriverModal: false,
      rmDriverId: null,

      // 锐明设置IP
      rmSetDriverIPModal: false,
      rmSetDriverIPId: null,

      // 锐明设置报警触发条件
      rmSetDriverAlarmConditionModal: false,
      rmSetDriverAlarmConditionId: null,

      // 设置上传间隔
      rmSetUploadIntervalModal: false,
      rmSetUploadIntervalId: null,

      // 锐明触发报警
      rmSetTriggerAlarmModal: false,
      rmSetTriggerAlarmId: null,

      // 锐明关闭SIM卡锁
      rmSetCloseSIMLockModal: false,
      rmSetCloseSIMLockId: null,

      // 锐明查询车辆参数
      rmQueryParametersModal: false,
      rmQueryParametersId: null,

      // 中天安驰设置司机卡
      ztSetDriverCardModal: false,
      ztSetDriverCardId: null,
      ztSetDriverCardterminalNum: null,

      // 中天安驰设置车辆参数
      ztSetDriverVehicleinfoModal: false,
      ztSetDriverVehicleinfoId: null,
      ztSetDriverVehicleinfoterminalNum: null,

      // 中天安驰设置速度报警
      ztSetDriverSpeedAlarmModal: false,
      ztSetDriverSpeedAlarmId: null,

      // 中天安驰批量设置速度报警
      ztDriverSpeedAlarmModal: false,
      ztDriverSpeedAlarmId: null,

      // 中天安驰磁盘格式化
      ztSetDiskFormattingModal: false,
      ztSetDiskFormattingId: null,

      // 中天安驰设置里程
      ztSetDriverMileageModal: false,
      ztSetDriverMileageId: null,

      // 中天安驰重启控制
      ztSetDriverRestartModal: false,
      ztSetDriverRestartId: null,

      // 中天安驰批量重启控制
      ztDriverRestartModal: false,
      ztDriverRestartId: null,

      // 中天安驰设置IP
      ztSetDriverCenternetworkModal: false,
      ztSetDriverCenternetworkId: null,

      // 中天安驰设置ADAS报警
      ztSetDriverAdasAlarmModal: false,
      ztSetDriverAdasAlarmId: null,

      // 中天安驰pi设置ADAS报警
      ztDriverAdasAlarmModal: false,
      ztDriverAdasAlarmId: null,

      // 中天安驰设置DSM报警
      ztSetDriverDsmAlarmModal: false,
      ztSetDriverDsmAlarmId: null,

      // 中天安驰批量设置DSM报警
      ztDriverDsmAlarmModal: false,
      ztDriverDsmAlarmId: null,

      // 中天安驰设置报警使能
      ztSetDriverAlarmEnablelModal: false,
      ztSetDriverAlarmEnablelId: null,

      // 中天安驰开启测试模式
      ztSetTestPatternModal: false,
      ztSetTestPatternId: null,

      // 中天触发报警
      ztSetTriggerAlarmModal: false,
      ztSetTriggerAlarmId: null,

      // 中天安驰批量设置报警使能
      ztDriverAlarmEnablelModal: false,
      ztDriverAlarmEnablelId: null,

      // 通立设置司机卡
      tlSetDriverCardModal: false,
      tlSetDriverCardId: null,
      tlSetDriverCardterminalNum: null,

      // 通立设置车辆参数
      tlSetDriverVehicleinfoModal: false,
      tlSetDriverVehicleinfoId: null,
      tlSetDriverVehicleinfoterminalNum: null,

      // 通立设置存储报警
      tlSetHardDiskSlarmModal: false,
      tlSetHardDiskSlarmId: null,
      tlSetHardDiskSlarmterminalNum: null,

      // 通立触发报警
      tlSetTriggerAlarmModal: false,
      tlSetTriggerAlarmId: null,

      //首航设置司机卡
      shSetDriverCardModal: false,
      shSetDriverCardId: null,
      shSetDriverCardterminalNum: null,

      // 首航设置车辆参数
      shSetDriverVehicleinfoModal: false,
      shSetDriverVehicleinfoId: null,
      shSetDriverVehicleinfoterminalNum: null,

      // 终端参数设置
      jt808SetParameterdataModal: false,
      jt808SetParameterdataId: null,
      jt808SetParameterdata: [],

      // 批量终端参数设置
      jt808SetBatchParameterdataModal: false,

      // 下发透传数据
      dataDownlinkTransmissionModal: false,
      dataDownlinkTransmissionId: null,

      // 部标视频指令
      jt1078CmdModal: false,
      jt1078CmdId: null,

      // 批量发送快捷指令
      jt808batchSendcmdModal: false,

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 设置里程
      setupBsjMileageModal: false,
      setupBsjMileageId: null,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      batchManufacturer: false,
      terminalNums: null,
      batchSendCmdModal: false,
      batchSendCmd: {
        terminalNums: [],
        urgent: false,
        cmd: null,
        settime: false,
        time: null,
        interval: null
      },

      setupReportIntervalModal: false,
      setupReportInterval: {
        id: null,
        accOn: 15,
        accOff: 120
      },

      terminalNumValue: null,
      // <EXTBE1驾驶员代码,驾驶证代码,驾驶员名,车架号,车牌号,车牌分类,发动机号,身份证号AA>
      // <EXTBE1驾驶员代码,驾驶证代码,驾驶员名,车架号,车牌号,车牌分类,发动机号,身份证号,从业资格证号,发证机构,有效期,AA>
      setupVehicleParamsModal: false,
      setupVehicleParams: {
        id: null,
        driverCardNum: null, // 驾驶员代码
        driverLicenseNum: null, // 驾驶证代码
        driverName: null, // 驾驶员名
        vin: null, // 车架号
        registrationNum: null, // 车牌号
        vehicleTypeName: null, // 车牌分类
        engineNum: null, // 发动机号
        terminalNum: null,// 主机号
        organizationNames: null,// 发证机构名称
        indate: null// 发证机构名称
      },

      showSendCommandModal: false,
      sendCommand: {
        id: 0,
        content: null,
        urgent: true
      },

      showSetupRegistrationNoModal: false,
      setupRegistration: {
        id: 0,
        registrationNum: null,
        registrationColor: 0
      },
      setupRegistrationNo: null,

      keywordFilter: null,
      refreshTimer: null,

      setPermissionsModalListStyle: {
        width: '300px',
        height: '300px'
      },

      // 添加角色Modal
      addJt808DeviceModal: false,
      addJt808Device_Name: '',
      addJt808Device_NickName: '',
      addJt808Device_Description: '',

      // 设置权限
      setPermissionsModal: false,
      setPermissions_UserId: 0,
      setPermissions_Titles: ['系统权限', '拥有权限'],
      setPermissions_OwnPermissions: [],
      setPermissions_AllPermissions: [],

      tableHeight: 160,
      progresshow: false,
      progresscount: 0,
      progresstatus: 'active',
      progressspeed: 0,
      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      pageIndex: 1,
      sort: null,

      page_user_list: [],
      lodding: false,
      list_loadding: false,
      columnsDisplay: [],
      columnHeaders: [],
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 80
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 130,
          render: (h, params) => {
            if (params.row.terminalNum) {
              return (h('Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.jt808MonitoringViewModal = true
                      // console.log(params.row)
                      this.jt808MonitoringViewId = params.row.id
                      this.jt808MonitoringViewterminalNum = params.row.terminalNum
                    }
                  }
                }, params.row.terminalNum

              )
              )
            } else {
              return h('div', null)
            }
          }
        },
        {
          title: '智能监管系统 ',
          resizable: true,
          key: 'ucdlysjgtdgdgovState',
          sortable: 'true',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          render: (h, params) => {
            let ucdlysjgtdgdgovState = params.row.ucdlysjgtdgdgovState
            if (ucdlysjgtdgdgovState === 0) {
              return h('div', '无资料')
            } else if (ucdlysjgtdgdgovState === 1) {
              return h('div', '正常')
            } else if (ucdlysjgtdgdgovState === 2) {
              return h('div', '未上传过卫星定位,未上传过报警,未上传过附件')
            } else if (ucdlysjgtdgdgovState === 3) {
              return h('div', '未上传过报警,未上传过附件')
            } else if (ucdlysjgtdgdgovState === 4) {
              return h('div', '未上传过附件')
            } else if (ucdlysjgtdgdgovState === 5) {
              return h('div', '设备停止服务')
            } else if (ucdlysjgtdgdgovState === 6) {
              return h('div', '非视频机设备')
            } else if (ucdlysjgtdgdgovState === 7) {
              return h('div', '定位时间不符')
            } else if (ucdlysjgtdgdgovState === 8) {
              return h('div', '无绑定设备')
            }
          }
        },
        {
          title: '制造商ID',
          resizable: true,
          key: 'manufacturerId',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110,
          render: (h, params) => {
            if (params.row.manufacturerId) {
              return h('label', parseInt(params.row.manufacturerId, 16))
            }
          }
        },
        {
          title: '终端型号',
          resizable: true,
          key: 'terminalModel',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110
        },
        {
          title: '终端ID',
          resizable: true,
          key: 'terminalId',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110
        },
        {
          title: 'ICCID',
          resizable: true,
          key: 'iccid',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110
        },
        {
          title: '匹配SIM号',
          resizable: true,
          key: 'SIMNum',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '硬件版本',
          resizable: true,
          key: 'hardwareVersion',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110
        },
        {
          title: '固件版本',
          resizable: true,
          key: 'firmwareVersion',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110
        },
        {
          title: '最后接收时间',
          resizable: true,
          key: 'lastRecvDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.lastRecvDatetime) {
              let d = new Date(params.row.lastRecvDatetime)
              return h('div', {}, d.Format('yyyy年MM月dd hh:mm:ss'))
            } else {
              return h('div', {}, '无')
            }
          }
        },
        {
          title: '最后定位时间',
          resizable: true,
          key: 'lastLocateDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.lastLocateDatetime) {
              let d = new Date(params.row.lastLocateDatetime)
              return h('div', {}, d.Format('yyyy年MM月dd hh:mm:ss'))
            } else {
              return h('div', {}, '无')
            }
          }
        },
        {
          title: '启用GPS',
          resizable: true,
          key: 'gpsEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.gpsEnableFilter = []
              val.forEach(item => {
                this.gpsEnableFilter.push(genQueryParam('gpsEnable', 'EQBOOL', item))
              })
            } else {
              this.gpsEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.gpsEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '启用北斗',
          resizable: true,
          key: 'beidouEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.beidouEnableFilter = []
              val.forEach(item => {
                this.beidouEnableFilter.push(genQueryParam('beidouEnable', 'EQBOOL', item))
              })
            } else {
              this.beidouEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.beidouEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '启用Galileo',
          resizable: true,
          key: 'galileoEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.galileoEnableFilter = []
              val.forEach(item => {
                this.galileoEnableFilter.push(genQueryParam('galileoEnable', 'EQBOOL', item))
              })
            } else {
              this.galileoEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.galileoEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '启用Glonass',
          resizable: true,
          key: 'glonassEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 150,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.glonassEnableFilter = []
              val.forEach(item => {
                this.glonassEnableFilter.push(genQueryParam('glonassEnable', 'EQBOOL', item))
              })
            } else {
              this.glonassEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.glonassEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '2019版本',
          resizable: true,
          key: 'after2019',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ]
        },
        {
          title: '状态',
          resizable: true,
          key: 'state',
          width: 110,
          ellipsis: 'true',
          tooltip: 'true',
          render: (h, params) => {
            const task_status = params.row.state
            if (task_status == 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    type: 'dot',
                    color: 'success'
                  }
                }, '行驶')
              ])
            } else if (task_status == 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    type: 'dot',
                    color: 'warning'
                  }
                }, '熄火')
              ])
            } else if (task_status == 0) {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    type: 'dot',
                    color: 'error'
                  }
                }, '离线')
              ])
            } else if (task_status == 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    type: 'dot',
                    color: 'blue'
                  }
                }, '停车未熄火')
              ])
            } else {
              // return h('div', [
              //   h('Tag', {
              //     props: {
              //       type: 'dot',
              //       color: "black"
              //     }
              //   }, "未知")
              // ]);
              // console.log('未知')
              // console.log(params.row)
              return h('div', task_status)
            }
          }
        },
        {
          title: '无线通信网络信号强度',
          resizable: true,
          key: 'rssi',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '定位卫星数',
          resizable: true,
          key: 'gnssCount',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '状态时长',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (!params.row.changeTerminalStateDatetime) {
              return h('label', '无')
            }
            let date3 = new Date().getTime() - params.row.changeTerminalStateDatetime
            let leave1 = date3
            let hours = Math.floor(leave1 / (3600 * 1000))
            // 计算相差分钟数
            let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
            let minutes = Math.floor(leave2 / (60 * 1000))
            // 计算相差秒数
            let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
            let seconds = Math.round(leave3 / 1000)
            let result = ''
            if (hours > 0) {
              result += hours + '小时'
            }
            if (minutes > 0) {
              result += minutes + '分'
            }
            if (seconds > 0) {
              result += seconds + '秒'
            }
            return h('label', result)
          }
        },
        {
          title: '速度',
          resizable: true,
          key: 'speed',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          render: (h, params) => {
            // if(params.row.speed){
            return h('label', params.row.speed / 10)
            // }else{
            //   return h('label', '无')
            // }
          }
        },
        {
          title: '系统车牌号',
          resizable: true,
          key: 'registrationNum',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          render: (h, params) => {
            // console.log(params.row)
            // console.log(params.row.registrationNum)

            if (params.row.registrationNum != null) {
              return h('div', params.row.registrationNum)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '设备上报车牌',
          resizable: true,
          key: 'collectRegistrationNo',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 130
        },
        {
          title: '发动机号',
          resizable: true,
          key: 'collectEngineNum',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '采集车架号',
          resizable: true,
          key: 'collectVin',
          tooltip: 'true',
          width: 120
        },
        {
          title: '车牌分类',
          resizable: true,
          key: 'collectVehicleType',
          sortable: 'custom',
          ellipsis: 'true',
          width: 130
        },
        {
          title: '采集司机卡号',
          resizable: true,
          key: 'collectDriverCardNum',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110
        },
        {
          title: '采集驾驶员名',
          resizable: true,
          key: 'collectDriverName',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110
        },
        {
          title: '采集驾驶证号',
          resizable: true,
          key: 'collectDriverLicenseNum',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180
        },
        {
          title: '采集信息',
          resizable: true,
          key: 'collectText',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180
        },
        {
          title: '采集时间',
          resizable: true,
          key: 'collectDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.collectDatetime) {
              let d = new Date(params.row.collectDatetime)
              return h('div', {}, d.Format('yyyy年MM月dd hh:mm:ss'))
            } else {
              return h('div', {}, '无')
            }
          }
        },
        {
          title: '实时驾驶员名',
          resizable: true,
          key: 'driverName',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 130
        },
        {
          title: '实时驾驶证号',
          resizable: true,
          key: 'driverLicenseNum',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 150
        },
        {
          title: '司机卡更新时间',
          resizable: true,
          key: 'driverCardReportDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.driverCardReportDatetime) {
              let d = new Date(params.row.driverCardReportDatetime)
              return h('div', {}, d.Format('yyyy年MM月dd hh:mm:ss'))
            } else {
              return h('div', {}, '无')
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'center',
          ellipsis: 'true',
          fixed: 'right',
          width: 530,
          render: (h, params) => {
            let display = []

            display.push(
              h('Dropdown', {
                props: {
                  // trigger: 'click',
                  transfer: true
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  'on-click': value => {
                    if (value === 'edit') {
                      this.$store.commit('fsfs/edit', params.row)
                      this.edit()
                    } else if (value === 'delete') {
                      console.log('点击了删除')
                    }
                  }
                }
              },
              [
                h(
                  'a',
                  {
                    href: 'javascript:void(0)',
                    props: {
                      type: 'primary',
                      size: 'small'
                    }
                  },
                  [
                    h('span', '设备设置'),
                    h('Icon', {
                      props: {
                        type: 'ios-arrow-down',
                        size: 18
                      }
                    })
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h(
                      'DropdownItem',
                      {
                        props: {
                          type: 'primary',
                          size: 'small'
                        }
                      },
                      [

                        /* 博实结 */
                        h('Dropdown', {
                          props: {
                            // trigger: 'click',
                            transfer: true,
                            placement: 'right-start'
                          },
                          style: {
                            marginRight: '5px'
                          },
                          on: {
                            'on-click': value => {
                              if (value === 'edit') {
                                this.$store.commit('fsfs/edit', params.row)
                                this.edit()
                              } else if (value === 'delete') {
                                console.log('点击了删除')
                              }
                            }
                          }
                        },
                        [
                          h(
                            'DropdownItem',
                            {
                              props: {
                                type: 'primary',
                                size: 'small'
                              }
                            },
                            [
                              h('span', '博实结'),
                              h('Icon', {
                                props: {
                                  type: 'ios-arrow-forward',
                                  size: 18
                                }
                              })
                            ]
                          ),
                          h(
                            'DropdownMenu',
                            {
                              slot: 'list'
                            },
                            [
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    store.dispatch('NetCommandServ_SendCommand', {
                                      params: { id: params.row.id, content: '<EXTBE0>', urgent: true }
                                    }).then(() => {
                                      this.$Message.success('发送成功')
                                    }).catch(err => {
                                      this.$Message.error(err)
                                    })
                                  }
                                }
                              }, '采集车辆信息'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.setupRegistration.id = params.row.id
                                    this.showSetupRegistrationNoModal = true
                                  }
                                }
                              }, '设置车牌'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.setupBsjMileageId = params.row.id
                                    this.setupBsjMileageModal = true
                                  }
                                }
                              }, '设置里程'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.setupVehicleParams.id = params.row.id
                                    this.setupVehicleParams.terminalNum = params.row.terminalNum
                                    this.setupVehicleParamsModal = true
                                    this.terminalNumValue = params.row.terminalNum
                                  }
                                }
                              }, '设置车辆参数'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.BsjSetMaxSpeedId = params.row.id
                                    this.BsjSetMaxSpeedModal = true
                                  }
                                }
                              }, '设置限速'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.bsjSetGFViewingScreenId = params.row.id
                                    this.bsjSetGFViewingScreenModal = true
                                  }
                                }
                              }, '设置倒车大屏'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.bsjSetDriverDetectionId = params.row.id
                                    this.bsjSetDriverDetectionModal = true
                                  }
                                }
                              }, '关闭驾驶员检测'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.bsjSetTriggerAlarmId = params.row.id
                                    this.bsjSetTriggerAlarmModal = true
                                  }
                                }
                              }, '触发报警')
                            ]
                          )
                        ]
                        )

                      ]
                    ),

                    h(
                      'DropdownItem',
                      {
                        props: {
                          type: 'primary',
                          size: 'small'
                        }
                      },
                      [

                        /* 海康 */
                        h('Dropdown', {
                          props: {
                            // trigger: 'click',
                            transfer: true,
                            placement: 'right-start'
                          },
                          style: {
                            marginRight: '5px'
                          },
                          on: {
                            // "on-click": value => {
                            //   if (value === "edit") {
                            //     this.$store.commit("fsfs/edit", params.row);
                            //     this.edit();
                            //   } else if (value === "delete") {
                            //     console.log("点击了删除");
                            //   }
                            // }
                          }
                        },
                        [
                          h(
                            'DropdownItem',
                            {
                              props: {
                                type: 'primary',
                                size: 'small'
                              }
                            },
                            [
                              h('span', '海康'),
                              h('Icon', {
                                props: {
                                  type: 'ios-arrow-forward',
                                  size: 18
                                }
                              })
                            ]
                          ),
                          h(
                            'DropdownMenu',
                            {
                              slot: 'list'
                            },
                            [
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.drivingRecorderDataUploadChange = true
                                    this.drivingRecorderDataUpload.id = params.row.id
                                  }
                                }
                              }, '采集信息'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.hikSetDriverCardId = params.row.id
                                    this.hikSetDriverCardModal = true
                                    this.hikSetDriverCardterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '写卡'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.hikSetDriverCardInstitutionId = params.row.id
                                    this.hikSetDriverCardInstitutionModal = true
                                  }
                                }
                              }, '发卡机构'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.hikSetDriverVehicleinfoRegistrationnumId = params.row.id
                                    this.hikSetDriverVehicleinfoRegistrationnumModal = true
                                  }
                                }
                              }, '设置车牌号'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.hikSetDriverVehicleinfoId = params.row.id
                                    this.hikSetDriverVehicleinfoModal = true
                                    this.hikSetDriverVehicleinfoterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '设置车辆参数'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.HikSetMileageId = params.row.id
                                    this.HikSetMileageModal = true
                                  }
                                }
                              }, '设置车辆里程'),
                              // h('DropdownItem', {
                              //   props: {
                              //     type: 'primary',
                              //     size: 'small',
                              //     disabled: false
                              //   },
                              //   style: {
                              //     marginRight: '5px'
                              //   },
                              //   nativeOn: {
                              //     click: () => {
                              //       this.hikSetAlarmModalId = params.row.id
                              //       this.hikSetAlarmModalModal = true
                              //     }
                              //   }
                              // }, '设置报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.hikSetTriggerAlarmModalId = params.row.id
                                    this.hikSetTriggerAlarmModalModal = true
                                  }
                                }
                              }, '触发报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.hikSetTravelTimeId = params.row.id
                                    this.hikSetTravelTimeModal = true
                                  }
                                }
                              }, '设置夜间行驶时长'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    // this.dataDownlinkTransmissionChange = true
                                    this.dataDownlinkTransmission.id = params.row.id
                                    this.onSendHIKdataDownlinkTransmission()
                                  }
                                }
                              }, '采集设备信息'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.dataDownlinkTransmissionChange = true
                                    this.dataDownlinkTransmission.id = params.row.id
                                    // this.onSendHIKHardDisk()
                                  }
                                }
                              }, '获取设备报警')
                            ]
                          )
                        ]
                        )

                      ]),

                    h(
                      'DropdownItem',
                      {
                        props: {
                          type: 'primary',
                          size: 'small'
                        }
                      },
                      [

                        h('Dropdown', {
                          props: {
                            // trigger: 'click',
                            transfer: true,
                            placement: 'right-start'
                          },
                          style: {
                            marginRight: '5px'
                          },
                          on: {
                            // "on-click": value => {
                            //   if (value === "edit") {
                            //     this.$store.commit("fsfs/edit", params.row);
                            //     this.edit();
                            //   } else if (value === "delete") {
                            //     console.log("点击了删除");
                            //   }
                            // }
                          }
                        },
                        [
                          h(
                            'DropdownItem',
                            {
                              props: {
                                type: 'primary',
                                size: 'small'
                              }
                            },
                            [
                              h('span', '锐明'),
                              h('Icon', {
                                props: {
                                  type: 'ios-arrow-forward',
                                  size: 18
                                }
                              })
                            ]
                          ),
                          //   h(
                          //   'DropdownMenu',
                          //   {
                          //     slot: 'list'
                          //   },
                          //   [
                          //     h('DropdownItem', {
                          //       props: {
                          //         type: 'primary',
                          //         size: 'small',
                          //         disabled: false
                          //       },
                          //       style: {
                          //         marginRight: '5px'
                          //       },
                          //       nativeOn: {
                          //         click: () => {
                          //           this.rmQueryParametersModal = true
                          //           this.rmQueryParametersId = params.row.id
                          //         }
                          //       }
                          //     }, '查询参数')
                          //   ]
                          // ),
                          h(
                            'DropdownMenu',
                            {
                              slot: 'list'
                            },
                            [
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.drivingRecorderDataUploadChange = true
                                    this.drivingRecorderDataUpload.id = params.row.id
                                  }
                                }
                              }, '采集信息'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetTravelTimeId = params.row.id
                                    this.rmSetTravelTimeModal = true
                                    this.rmSetTravelTimeterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '写卡'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetDriverVehicleinfoId = params.row.id
                                    this.rmSetDriverVehicleinfoModal = true
                                    this.rmSetDriverVehicleinfoterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '设置车辆参数'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetDriverParametersId = params.row.id
                                    this.rmSetDriverParametersModal = true
                                  }
                                }
                              }, '设置参数'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetDriverId = params.row.id
                                    this.rmSetDriverModal = true
                                  }
                                }
                              }, '设置协议'),
                              // h('DropdownItem', {
                              //   props: {
                              //     type: 'primary',
                              //     size: 'small',
                              //     disabled: false
                              //   },
                              //   style: {
                              //     marginRight: '5px'
                              //   },
                              //   nativeOn: {
                              //     click: () => {
                              //       this.rmSetDriverIPId = params.row.id
                              //       this.rmSetDriverIPModal = true
                              //     }
                              //   }
                              // }, '设置IP'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetDriverAlarmConditionId = params.row.id
                                    this.rmSetDriverAlarmConditionModal = true
                                  }
                                }
                              }, '设置报警触发'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetUploadIntervalId = params.row.id
                                    this.rmSetUploadIntervalModal = true
                                  }
                                }
                              }, '设置上传间隔'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetTriggerAlarmId = params.row.id
                                    this.rmSetTriggerAlarmModal = true
                                  }
                                }
                              }, '触发报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.rmSetCloseSIMLockId = params.row.id
                                    this.rmSetCloseSIMLockModal = true
                                  }
                                }
                              }, '关闭SIM卡锁')
                            ]
                          )
                        ]
                        )

                      ]
                    ),

                    h(
                      'DropdownItem',
                      {
                        props: {
                          type: 'primary',
                          size: 'small'
                        }
                      },
                      [

                        /* 中天安驰 */
                        h('Dropdown', {
                          props: {
                            // trigger: 'click',
                            transfer: true,
                            placement: 'right-start'
                          },
                          style: {
                            marginRight: '5px'
                          },
                          on: {
                            // "on-click": value => {
                            //   if (value === "edit") {
                            //     this.$store.commit("fsfs/edit", params.row);
                            //     this.edit();
                            //   } else if (value === "delete") {
                            //     console.log("点击了删除");
                            //   }
                            // }
                          }
                        },
                        [
                          h(
                            'DropdownItem',
                            {
                              props: {
                                type: 'primary',
                                size: 'small'
                              }
                            },
                            [
                              h('span', '中天安驰'),
                              h('Icon', {
                                props: {
                                  type: 'ios-arrow-forward',
                                  size: 18
                                }
                              })
                            ]
                          ),
                          h(
                            'DropdownMenu',
                            {
                              slot: 'list'
                            },
                            [
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.drivingRecorderDataUploadChange = true
                                    this.drivingRecorderDataUpload.id = params.row.id
                                  }
                                }
                              }, '采集信息'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverCardId = params.row.id
                                    this.ztSetDriverCardModal = true
                                    this.ztSetDriverCardterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '写卡'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverVehicleinfoId = params.row.id
                                    this.ztSetDriverVehicleinfoModal = true
                                    this.ztSetDriverVehicleinfoterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '设置车辆参数'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverSpeedAlarmId = params.row.id
                                    this.ztSetDriverSpeedAlarmModal = true
                                  }
                                }
                              }, '设置速度报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverMileageId = params.row.id
                                    this.ztSetDriverMileageModal = true
                                  }
                                }
                              }, '设置里程'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverRestartId = params.row.id
                                    this.ztSetDriverRestartModal = true
                                  }
                                }
                              }, '重启控制'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDiskFormattingId = params.row.id
                                    this.ztSetDiskFormattingModal = true
                                  }
                                }
                              }, '磁盘格式化'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverCenternetworkId = params.row.id
                                    this.ztSetDriverCenternetworkModal = true
                                  }
                                }
                              }, '设置IP'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverAdasAlarmId = params.row.id
                                    this.ztSetDriverAdasAlarmModal = true
                                  }
                                }
                              }, 'ADAS报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverDsmAlarmId = params.row.id
                                    this.ztSetDriverDsmAlarmModal = true
                                  }
                                }
                              }, 'DSM报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetDriverAlarmEnablelId = params.row.id
                                    this.ztSetDriverAlarmEnablelModal = true
                                  }
                                }
                              }, '报警使能'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetTestPatternId = params.row.id
                                    this.ztSetTestPatternModal = true
                                  }
                                }
                              }, '测试模式'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.ztSetTriggerAlarmId = params.row.id
                                    this.ztSetTriggerAlarmModal = true
                                  }
                                }
                              }, '触发报警')
                            ]
                          )
                        ]
                        )
                      ]
                    ),

                    h(
                      'DropdownItem',
                      {
                        props: {
                          type: 'primary',
                          size: 'small'
                        }
                      },
                      [

                        /* 通立 */
                        h('Dropdown', {
                          props: {
                            // trigger: 'click',
                            transfer: true,
                            placement: 'right-start'
                          },
                          style: {
                            marginRight: '5px'
                          },
                          on: {
                            // "on-click": value => {
                            //   if (value === "edit") {
                            //     this.$store.commit("fsfs/edit", params.row);
                            //     this.edit();
                            //   } else if (value === "delete") {
                            //     console.log("点击了删除");
                            //   }
                            // }
                          }
                        },
                        [
                          h(
                            'DropdownItem',
                            {
                              props: {
                                type: 'primary',
                                size: 'small'
                              }
                            },
                            [
                              h('span', '通立'),
                              h('Icon', {
                                props: {
                                  type: 'ios-arrow-forward',
                                  size: 18
                                }
                              })
                            ]
                          ),
                          h(
                            'DropdownMenu',
                            {
                              slot: 'list'
                            },
                            [
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.drivingRecorderDataUploadChange = true
                                    this.drivingRecorderDataUpload.id = params.row.id
                                  }
                                }
                              }, '采集信息'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.tlSetDriverCardId = params.row.id
                                    this.tlSetDriverCardModal = true
                                    this.tlSetDriverCardterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '写卡'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.tlSetDriverVehicleinfoId = params.row.id
                                    this.tlSetDriverVehicleinfoModal = true
                                    this.tlSetDriverVehicleinfoterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '设置车辆参数'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.tlSetHardDiskSlarmId = params.row.id
                                    this.tlSetHardDiskSlarmModal = true
                                    this.tlSetHardDiskSlarmterminalNum = params.row.terminalNum
                                  }
                                }
                              }, '设置存储报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    this.tlSetTriggerAlarmId = params.row.id
                                    this.tlSetTriggerAlarmModal = true
                                  }
                                }
                              }, '触发报警'),
                              h('DropdownItem', {
                                props: {
                                  type: 'primary',
                                  size: 'small',
                                  disabled: false
                                },
                                style: {
                                  marginRight: '5px'
                                },
                                nativeOn: {
                                  click: () => {
                                    // this.dataDownlinkTransmissionChange = true
                                    this.dataDownlinkTransmission.id = params.row.id
                                    this.onSendHIKdataDownlinkTransmission()
                                  }
                                }
                              }, '采集设备信息')

                            ]
                          )
                        ]
                        )

                      ]),

                    h(
                      'DropdownItem',
                      {
                        props: {
                          type: 'primary',
                          size: 'small'
                        }
                      },
                      [

                        /* 首航 */
                        h('Dropdown', {
                            props: {
                              // trigger: 'click',
                              transfer: true,
                              placement: 'right-start'
                            },
                            style: {
                              marginRight: '5px'
                            },
                            on: {
                              // "on-click": value => {
                              //   if (value === "edit") {
                              //     this.$store.commit("fsfs/edit", params.row);
                              //     this.edit();
                              //   } else if (value === "delete") {
                              //     console.log("点击了删除");
                              //   }
                              // }
                            }
                          },
                          [
                            h(
                              'DropdownItem',
                              {
                                props: {
                                  type: 'primary',
                                  size: 'small'
                                }
                              },
                              [
                                h('span', '首航'),
                                h('Icon', {
                                  props: {
                                    type: 'ios-arrow-forward',
                                    size: 18
                                  }
                                })
                              ]
                            ),
                            h(
                              'DropdownMenu',
                              {
                                slot: 'list'
                              },
                              [
                                h('DropdownItem', {
                                  props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: false
                                  },
                                  style: {
                                    marginRight: '5px'
                                  },
                                  nativeOn: {
                                    click: () => {
                                      this.drivingRecorderDataUploadChange = true
                                      this.drivingRecorderDataUpload.id = params.row.id
                                    }
                                  }
                                }, '采集信息'),
                                h('DropdownItem', {
                                  props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: false
                                  },
                                  style: {
                                    marginRight: '5px'
                                  },
                                  nativeOn: {
                                    click: () => {
                                      this.shSetDriverCardId = params.row.id
                                      this.shSetDriverCardModal = true
                                      this.shSetDriverCardterminalNum = params.row.terminalNum
                                    }
                                  }
                                }, '写卡'),
                                h('DropdownItem', {
                                  props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: false
                                  },
                                  style: {
                                    marginRight: '5px'
                                  },
                                  nativeOn: {
                                    click: () => {
                                      this.shSetDriverVehicleinfoId = params.row.id
                                      this.shSetDriverVehicleinfoModal = true
                                      this.shSetDriverVehicleinfoterminalNum = params.row.terminalNum
                                    }
                                  }
                                }, '设置车辆参数'),
                                h('DropdownItem', {
                                  props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: false
                                  },
                                  style: {
                                    marginRight: '5px'
                                  },
                                  nativeOn: {
                                    click: () => {
                                      // this.dataDownlinkTransmissionChange = true
                                      this.dataDownlinkTransmission.id = params.row.id
                                      this.onSendHIKdataDownlinkTransmission()
                                    }
                                  }
                                }, '采集设备信息')

                              ]
                            )
                          ]
                        )

                      ])

                  ]
                )
              ]
              )
            )

            // /**
            //  *  博实杰
            //  */
            // display.push(
            //   h('Dropdown', {
            //     props: {
            //       trigger: 'click',
            //       transfer: true
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       'on-click': value => {
            //         if (value === 'edit') {
            //           this.$store.commit('fsfs/edit', params.row)
            //           this.edit()
            //         } else if (value === 'delete') {
            //           console.log('点击了删除')
            //         }
            //       }
            //     }
            //   },
            //   [
            //     h(
            //       'Button',
            //       {
            //         props: {
            //           type: 'primary',
            //           size: 'small'
            //         }
            //       },
            //       [
            //         h('span', '博实结'),
            //         h('Icon', {
            //           props: {
            //             type: 'ios-cog',
            //             size: 18
            //           }
            //         })
            //       ]
            //     ),
            //     h(
            //       'DropdownMenu',
            //       {
            //         slot: 'list'
            //       },
            //       [
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               store.dispatch('NetCommandServ_SendCommand', {
            //                 params: { id: params.row.id, content: '<EXTBE0>', urgent: true }
            //               }).then(() => {
            //                 this.$Message.success('发送成功')
            //               }).catch(err => {
            //                 this.$Message.error(err)
            //               })
            //             }
            //           }
            //         }, '采集车辆信息'),
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               this.setupRegistration.id = params.row.id
            //               this.showSetupRegistrationNoModal = true
            //             }
            //           }
            //         }, '设置车牌'),
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               this.setupBsjMileageId = params.row.id
            //               this.setupBsjMileageModal = true
            //             }
            //           }
            //         }, '设置里程'),
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               this.setupVehicleParams.id = params.row.id
            //               this.setupVehicleParams.terminalNum = params.row.terminalNum
            //               this.setupVehicleParamsModal = true
            //             }
            //           }
            //         }, '设置车辆参数')
            //       ]
            //     )
            //   ]
            //   )
            // )
            //
            // /**
            //  *  海康
            //  */
            // display.push(
            //   h('Dropdown', {
            //     props: {
            //       trigger: 'click',
            //       transfer: true
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       // "on-click": value => {
            //       //   if (value === "edit") {
            //       //     this.$store.commit("fsfs/edit", params.row);
            //       //     this.edit();
            //       //   } else if (value === "delete") {
            //       //     console.log("点击了删除");
            //       //   }
            //       // }
            //     }
            //   },
            //   [
            //     h(
            //       'Button',
            //       {
            //         props: {
            //           type: 'primary',
            //           size: 'small'
            //         }
            //       },
            //       [
            //         h('span', '海康'),
            //         h('Icon', {
            //           props: {
            //             type: 'ios-cog',
            //             size: 18
            //           }
            //         })
            //       ]
            //     ),
            //     h(
            //       'DropdownMenu',
            //       {
            //         slot: 'list'
            //       },
            //       [
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               this.hikSetDriverCardId = params.row.id
            //               this.hikSetDriverCardModal = true
            //               this.hikSetDriverCardterminalNum = params.row.terminalNum
            //             }
            //           }
            //         }, '写卡')
            //       ]
            //     ),
            //     h(
            //       'DropdownMenu',
            //       {
            //         slot: 'list'
            //       },
            //       [
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               this.hikSetDriverVehicleinfoRegistrationnumId = params.row.id
            //               this.hikSetDriverVehicleinfoRegistrationnumModal = true
            //             }
            //           }
            //         }, '设置车牌号')
            //       ]
            //     ),
            //     h(
            //       'DropdownMenu',
            //       {
            //         slot: 'list'
            //       },
            //       [
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               this.hikSetDriverVehicleinfoId = params.row.id
            //               this.hikSetDriverVehicleinfoModal = true
            //             }
            //           }
            //         }, '设置车辆参数')
            //       ]
            //     ),
            //     h(
            //       'DropdownMenu',
            //       {
            //         slot: 'list'
            //       },
            //       [
            //         h('DropdownItem', {
            //           props: {
            //             type: 'primary',
            //             size: 'small',
            //             disabled: false
            //           },
            //           style: {
            //             marginRight: '5px'
            //           },
            //           nativeOn: {
            //             click: () => {
            //               this.hikSetTravelTimeId = params.row.id
            //               this.hikSetTravelTimeModal = true
            //             }
            //           }
            //         }, '设置夜间行驶时长')
            //       ]
            //     ),
            //   ]
            //   )
            // )
            //
            // /**
            //  *  锐明
            //  */
            // display.push(
            //   h('Dropdown', {
            //       props: {
            //         trigger: 'click',
            //         transfer: true
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         // "on-click": value => {
            //         //   if (value === "edit") {
            //         //     this.$store.commit("fsfs/edit", params.row);
            //         //     this.edit();
            //         //   } else if (value === "delete") {
            //         //     console.log("点击了删除");
            //         //   }
            //         // }
            //       }
            //     },
            //     [
            //       h(
            //         'Button',
            //         {
            //           props: {
            //             type: 'primary',
            //             size: 'small'
            //           }
            //         },
            //         [
            //           h('span', '锐明'),
            //           h('Icon', {
            //             props: {
            //               type: 'ios-cog',
            //               size: 18
            //             }
            //           })
            //         ]
            //       ),
            //     //   h(
            //     //   'DropdownMenu',
            //     //   {
            //     //     slot: 'list'
            //     //   },
            //     //   [
            //     //     h('DropdownItem', {
            //     //       props: {
            //     //         type: 'primary',
            //     //         size: 'small',
            //     //         disabled: false
            //     //       },
            //     //       style: {
            //     //         marginRight: '5px'
            //     //       },
            //     //       nativeOn: {
            //     //         click: () => {
            //     //           this.rmQueryParametersModal = true
            //     //           this.rmQueryParametersId = params.row.id
            //     //         }
            //     //       }
            //     //     }, '查询参数')
            //     //   ]
            //     // ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.rmSetTravelTimeId = params.row.id
            //                 this.rmSetTravelTimeModal = true
            //               }
            //             }
            //           }, '写卡')
            //         ]
            //       ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.rmSetDriverVehicleinfoId = params.row.id
            //                 this.rmSetDriverVehicleinfoModal = true
            //               }
            //             }
            //           }, '设置车辆参数')
            //         ]
            //       ),
            //     ]
            //   )
            // )
            //
            // /**
            //  *  中天安驰
            //  */
            // display.push(
            //   h('Dropdown', {
            //       props: {
            //         trigger: 'click',
            //         transfer: true
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         // "on-click": value => {
            //         //   if (value === "edit") {
            //         //     this.$store.commit("fsfs/edit", params.row);
            //         //     this.edit();
            //         //   } else if (value === "delete") {
            //         //     console.log("点击了删除");
            //         //   }
            //         // }
            //       }
            //     },
            //     [
            //       h(
            //         'Button',
            //         {
            //           props: {
            //             type: 'primary',
            //             size: 'small'
            //           }
            //         },
            //         [
            //           h('span', '中天安驰'),
            //           h('Icon', {
            //             props: {
            //               type: 'ios-cog',
            //               size: 18
            //             }
            //           })
            //         ]
            //       ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.ztSetDriverCardId = params.row.id
            //                 this.ztSetDriverCardModal = true
            //               }
            //             }
            //           }, '写卡')
            //         ]
            //       ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.ztSetDriverVehicleinfoId = params.row.id
            //                 this.ztSetDriverVehicleinfoModal = true
            //               }
            //             }
            //           }, '设置车辆参数')
            //         ]
            //       ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.ztSetDriverSpeedAlarmId = params.row.id
            //                 this.ztSetDriverSpeedAlarmModal = true
            //               }
            //             }
            //           }, '设置速度报警')
            //         ]
            //       ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.ztSetDiskFormattingId = params.row.id
            //                 this.ztSetDiskFormattingModal = true
            //               }
            //             }
            //           }, '磁盘格式化')
            //         ]
            //       ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.ztSetDriverMileageId = params.row.id
            //                 this.ztSetDriverMileageModal = true
            //               }
            //             }
            //           }, '设置里程')
            //         ]
            //       ),
            //       h(
            //         'DropdownMenu',
            //         {
            //           slot: 'list'
            //         },
            //         [
            //           h('DropdownItem', {
            //             props: {
            //               type: 'primary',
            //               size: 'small',
            //               disabled: false
            //             },
            //             style: {
            //               marginRight: '5px'
            //             },
            //             nativeOn: {
            //               click: () => {
            //                 this.ztSetDriverRestartId = params.row.id
            //                 this.ztSetDriverRestartModal = true
            //               }
            //             }
            //           }, '重启控制')
            //         ]
            //       ),
            //     ]
            //   )
            // )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    store.dispatch('PositioningDeviceInfoServ_GetPage', {
                      params: null,
                      urlparams: {
                        q: genQueryParam('terminalNum', 'EQ', params.row.terminalNum)
                      }
                    }).then(() => {
                      if (store.getters.get_PositioningDeviceInfo_GetPageResult) {
                        if (store.getters.get_PositioningDeviceInfo_GetPageResult.content.length > 0) {
                          this.vehicleInfoDetailId = store.getters.get_PositioningDeviceInfo_GetPageResult.content[0].vehicleInfoId
                          this.vehicleInfoDetailModal = true
                        } else {
                          this.$Message.error('没有绑定车辆信息')
                        }
                      }
                    }).catch(err => {
                      this.$Message.error(err)
                    })
                  }
                }
              }, '车辆信息')
            )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    store.dispatch('NetCommandServ_QueryTerminalAttribute', {
                      params: { id: params.row.id }
                    }).then(() => {
                      this.$Message.success('发送成功')
                    }).catch(err => {
                      this.$Message.error(err)
                    })
                  }
                }
              }, '查询属性')
            )

            /**
               * 设置终端参数
               */
            display.push(
              h('Dropdown', {
                props: {
                  trigger: 'click',
                  transfer: true
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  // "on-click": value => {
                  //   if (value === "edit") {
                  //     this.$store.commit("fsfs/edit", params.row);
                  //     this.edit();
                  //   } else if (value === "delete") {
                  //     console.log("点击了删除");
                  //   }
                  // }
                }
              },
              [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    }
                  },
                  [
                    h('span', '设置终端参数'),
                    h('Icon', {
                      props: {
                        type: 'ios-cog',
                        size: 18
                      }
                    })
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setupReportInterval.id = params.row.id
                          this.setupReportIntervalModal = true
                        }
                      }
                    }, '设置汇报间隔'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetFatigueDrivingAlarmDifferenceModal = true
                          this.jt808SetFatigueDrivingAlarmDifferenceId = params.row.terminalNum
                        }
                      }
                    }, '设置疲劳驾驶预警差值'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetOverSpeedAlarmDifferenceModal = true
                          this.jt808SetOverSpeedAlarmDifferenceId = params.row.terminalNum
                        }
                      }
                    }, '设置超速报警预警差值'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetMaxStopTimeModal = true
                          this.jt808SetMaxStopTimeId = params.row.terminalNum
                        }
                      }
                    }, '设置最长停车时间'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetMinRestingTimeModal = true
                          this.jt808SetMinRestingTimeId = params.row.terminalNum
                        }
                      }
                    }, '设置最小休息时间'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetContinueDriveLimitPerDayModal = true
                          this.jt808SetContinueDriveLimitPerDayId = params.row.terminalNum
                        }
                      }
                    }, '设置当天累计驾驶时间门限'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetContinueDriveLimitModal = true
                          this.jt808SetContinueDriveLimitId = params.row.terminalNum
                        }
                      }
                    }, '设置连续驾驶时间门限'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetOverSpeedDurationModal = true
                          this.jt808SetOverSpeedDurationId = params.row.terminalNum
                        }
                      }
                    }, '设置超速持续时间'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.jt808SetMaxSpeedModal = true
                          this.jt808SetMaxSpeedId = params.row.terminalNum
                        }
                      }
                    }, '设置最高速度')
                  ]
                )
              ]
              )
            )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.sendCommand.id = params.row.id
                    this.sendCommand.urgent = true
                    this.showSendCommandModal = true
                  }
                }
              }, '发送指令')
            )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认重启该设备',
                      content: '<p>确认重启该设备</p>',
                      onOk: () => {
                        store.dispatch('NetCommandServ_Restart', {
                          params: { id: params.row.id }
                        }).then(() => {
                          this.$Message.success('发送成功')
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {
                      }
                    })
                  }
                }
              }, '重启终端')
            )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.jt1078CmdModal = true
                    this.jt1078CmdId = params.row.id
                  }
                }
              }, '视频指令')
            )

            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.jt808SetParameterdataModal = true
            //         this.jt808SetParameterdataId = params.row.id
            //         this.jt808SetParameterdata = params.row.terminalNum
            //       }
            //     }
            //   }, '终端参数设置')
            // )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.dataDownlinkTransmissionModal = true
                    this.dataDownlinkTransmissionId = params.row.id
                  }
                }
              }, '透传')
            )

            return h('div', display)
          }// render
        }// {
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'NetCommandServ_BatchSendCmd',
      'NetCommandServ_SetupRegistration'
    ]),
    getManufacturer (e) {
      console.log(e)
      if (e != '请选择') {
        this.terminalNums = null
        this.batchSendCmd.terminalNums = []
        store.dispatch('PositioningDeviceInfoServ_GetTerminalnumForManufacturer', {
          params: {
            manufacturer: e
          },
          urlparams: {}
        }).then(res => {
          console.log(res)
          // store.getters.get_PositioningDeviceInfo_GetTerminalnumForManufacturerResult
          // this.batchSendCmd.terminalNums = []
          store.getters.get_PositioningDeviceInfo_GetTerminalnumForManufacturerResult.forEach(item => {
            this.batchSendCmd.terminalNums.push(item.terminalNum)
          })

          this.terminalNums = this.batchSendCmd.terminalNums.toString()
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.terminalNums = null
        this.batchSendCmd.terminalNums = []
      }
    },
    BSJ_Collect () {
      this.batchSendCmd.cmd = '<EXTBE0>'
      this.batchSendCmd.urgent = true
    },
    HIK_TravelTime (batchSendCmd) {
      this.batchSendCmd.cmd = batchSendCmd.cmd
      this.batchSendCmd.urgent = batchSendCmd.urgent
      this.hikTravelTimeModal = false
    },
    RM_Driver (batchSendCmd) {
      this.batchSendCmd.cmd = batchSendCmd.cmd
      this.batchSendCmd.urgent = batchSendCmd.urgent
      this.rmDriverModal = false
    },
    ZT_DriverSpeedAlarm (batchSendCmd) {
      this.batchSendCmd.cmd = batchSendCmd.cmd
      this.batchSendCmd.urgent = batchSendCmd.urgent
      this.ztDriverSpeedAlarmModal = false
    },
    ZT_DriverRestart (batchSendCmd) {
      this.batchSendCmd.cmd = batchSendCmd.cmd
      this.batchSendCmd.urgent = batchSendCmd.urgent
      this.ztDriverRestartModal = false
    },
    ZT_DriverAdasAlarm (batchSendCmd) {
      this.batchSendCmd.cmd = batchSendCmd.cmd
      this.batchSendCmd.urgent = batchSendCmd.urgent
      this.ztDriverAdasAlarmModal = false
    },
    ZT_DriverDsmAlarm (batchSendCmd) {
      this.batchSendCmd.cmd = batchSendCmd.cmd
      this.batchSendCmd.urgent = batchSendCmd.urgent
      this.ztDriverDsmAlarmModal = false
    },
    ZT_DriverAlarmEnablel (batchSendCmd) {
      this.batchSendCmd.cmd = batchSendCmd.cmd
      this.batchSendCmd.urgent = batchSendCmd.urgent
      this.ztDriverAlarmEnablelModal = false
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onResetAllReportInterval () {
      this.jt808SetAllReportIntervalModal = true
    },
    onSetupReportInterval () {
      store.dispatch('NetCommandServ_SetupReportInterval', {
        params: this.setupReportInterval
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onCleanVehicleParams () {
      // this.setupVehicleParams.id = null
      this.setupVehicleParams.driverCardNum = null
      this.setupVehicleParams.driverLicenseNum = null
      this.setupVehicleParams.driverName = null
      this.setupVehicleParams.vin = null
      this.setupVehicleParams.registrationNum = null
      this.setupVehicleParams.vehicleTypeName = null
      this.setupVehicleParams.engineNum = null
      this.setupVehicleParams.organizationNames = null
      this.setupVehicleParams.indate = null
    },
    visibleChange (val) {
      if (val) {
        this.onCleanVehicleParams()
        store.dispatch('PositioningDeviceInfoServ_SearchByName', {
          params: {
            name: this.terminalNumValue
          },
          urlparams: null
        }).then(res => {
          if (store.getters.get_PositioningDeviceInfo_SearchByNameResult && store.getters.get_PositioningDeviceInfo_SearchByNameResult.length > 0) {
            console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult)
            let vehicleInfoId = store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].vehicleInfoId
            if (vehicleInfoId != null) {
              store.dispatch('VehicleInfoServ_GetDetail', {
                params: {
                  id: vehicleInfoId
                },
                urlparams: null
              }).then(res => {
                if (store.getters.get_VehicleInfo_GetDetailResult) {
                  let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                  this.setupVehicleParams.vin = vehicleInfo.vin
                  this.setupVehicleParams.registrationNum = vehicleInfo.registrationNum
                  if (vehicleInfo.vehicleType != null) {
                    this.setupVehicleParams.vehicleTypeName = vehicleInfo.vehicleType.name
                  }
                  this.setupVehicleParams.engineNum = vehicleInfo.engineNum
                }
              }).catch(err => {

              })
            } else {
              console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId)
              store.dispatch('InstallOrderServ_GetDetail', {
                params: {
                  id: store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId
                },
                urlparams: null
              }).then(res => {
                if (store.getters.get_InstallOrder_GetDetailResult) {
                  let installOrder = store.getters.get_InstallOrder_GetDetailResult
                  this.setupVehicleParams.vin = installOrder.tempVehicleInfo.vin
                  this.setupVehicleParams.registrationNum = installOrder.tempVehicleInfo.registrationNum
                  if (installOrder.tempVehicleInfo.vehicleType != null) {
                    this.setupVehicleParams.vehicleTypeName = installOrder.tempVehicleInfo.vehicleType.name
                  }
                  this.setupVehicleParams.engineNum = installOrder.tempVehicleInfo.engineNum
                }
              }).catch(err => {

              })
            }
          }
        }).catch(err => {

        })
      }
    },
    onSetupVehicleParams () {
      // <EXTBE1司机卡号,驾驶证号,司机姓名,车架号,车牌号,车牌分类,发动机号,身份证号,从业资格证号,发证机构,证件有效期（YYMMDD）,AA>
      //<EXTBE1126175X,51082419761126175X,罗军益    ,YV2XG20CXHA811087,粤T73876    ,重型半挂牵引,D13C460SEUV711970,51082419761126175X  ,51082419761126175X  ,中山市交通运输局              ,301230,AA>
      let cmd = '<EXTBE1'
      if (this.setupVehicleParams.driverCardNum) {
        let driverCardNum = this.setupVehicleParams.driverCardNum
        let spaceCount = 7 - getWordsCount(driverCardNum)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            driverCardNum = driverCardNum + ' '
          }
        }
        cmd = cmd + driverCardNum + ','
      } else {
        cmd = cmd + ','
      }
      if (this.setupVehicleParams.driverLicenseNum) {
        let driverLicenseNum = this.setupVehicleParams.driverLicenseNum
        let spaceCount = 18 - getWordsCount(driverLicenseNum)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            driverLicenseNum = driverLicenseNum + ' '
          }
        }
        cmd = cmd + driverLicenseNum + ','
      } else {
        cmd = cmd + ','
      }
      if (this.setupVehicleParams.driverName) {
        let driverName = this.setupVehicleParams.driverName
        let spaceCount = 10 - getWordsCount(driverName)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            driverName = driverName + ' '
          }
        }
        cmd = cmd + driverName + ','
      } else {
        cmd = cmd + ','
      }
      if (this.setupVehicleParams.vin) {
        let vin = this.setupVehicleParams.vin
        let spaceCount = 17 - getWordsCount(vin)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            vin = vin + ' '
          }
        }
        cmd = cmd + vin + ','
      } else {
        cmd = cmd + ','
      }
      if (this.setupVehicleParams.registrationNum) {
        let registrationNum = this.setupVehicleParams.registrationNum
        let spaceCount = 12 - getWordsCount(registrationNum)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            registrationNum = registrationNum + ' '
          }
        }
        cmd = cmd + registrationNum + ','
      } else {
        cmd = cmd + ','
      }
      if (this.setupVehicleParams.vehicleTypeName) {
        let vehicleTypeName = this.setupVehicleParams.vehicleTypeName
        let spaceCount = 12 - getWordsCount(vehicleTypeName)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            vehicleTypeName = vehicleTypeName + ' '
          }
        }
        cmd = cmd + vehicleTypeName + ','
      } else {
        cmd = cmd + ','
      }
      if (this.setupVehicleParams.engineNum) {
        cmd = cmd + this.setupVehicleParams.engineNum + ','
      } else {
        cmd = cmd + ','
      }
      if (this.setupVehicleParams.driverLicenseNum) {
        let driverLicenseNum = this.setupVehicleParams.driverLicenseNum
        let spaceCount = 20 - getWordsCount(driverLicenseNum)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            driverLicenseNum = driverLicenseNum + ' '
          }
        }
        cmd = cmd + driverLicenseNum + ','
      }
      if (this.setupVehicleParams.driverLicenseNum) {
        let driverLicenseNum = this.setupVehicleParams.driverLicenseNum
        let spaceCount = 20 - getWordsCount(driverLicenseNum)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            driverLicenseNum = driverLicenseNum + ' '
          }
        }
        cmd = cmd + driverLicenseNum + ','
      }
      if (this.setupVehicleParams.organizationNames) {
        let organizationNames = this.setupVehicleParams.organizationNames
        let spaceCount = 30 - getWordsCount(organizationNames)
        if (spaceCount > 0) {
          for (var i = 0; i < spaceCount; i++) {
            organizationNames = organizationNames + ' '
          }
        }
        cmd = cmd + organizationNames + ','
      }
      // if (this.setupVehicleParams.organizationNames) {
      //   cmd = cmd + this.setupVehicleParams.organizationNames + ','
      // }
      if (this.setupVehicleParams.indate) {
        cmd = cmd + this.setupVehicleParams.indate.Format('yyMMdd') + ','
      } else {
        cmd = cmd + ','
      }
      cmd = cmd + 'AA>'
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this.setupVehicleParams.id, content: cmd, urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
        let queryParams = []
        queryParams.push(genQueryParam('terminalNum', 'EQ', this.setupVehicleParams.terminalNum))
        store.dispatch('DriverCardDataResultServ_GetPage', {
          params: null,
          urlparams: {
            q: queryParams
          }
        }).then(res => {
          // console.log(res)
          if (store.getters.get_DriverCardDataResult_GetPageResult) {
            // console.log(store.getters.get_DriverCardDataResult_GetPageResult)
            let driverCardDataResults = store.getters.get_DriverCardDataResult_GetPageResult.content
            for (let i = 0; i < driverCardDataResults.length; i++) {
              if (driverCardDataResults[i].processState != 3) {
                driverCardDataResults[i].processRemark = '写卡'
                driverCardDataResults[i].processState = 3
                store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
                  params: driverCardDataResults[i]
                }).then(() => {
                  // this.refreshPage(this.pageFilter)
                }).catch(err => {
                  this.$Message.error(err)
                })
              }
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onsettimeBatchSendCmd () {
      if (this.batchSendCmd.settime) {
        if (this.batchSendCmd.time == null) {
          this.$Message.error('请设置时长')
          return
        }
        if (this.batchSendCmd.interval == null) {
          this.batchSendCmd.interval = setInterval(
            this.onBatchSendCmd
            , this.batchSendCmd.time * 1000)
        } else {
          this.batchSendCmd.interval = setInterval(
            this.onBatchSendCmd
            , this.batchSendCmd.time * 1000)
        }
      } else {
        clearInterval(this.batchSendCmd.interval)
      }
    },
    onBatchSendCmd () {
      if (!this.terminalNums || this.terminalNums === '') {
        this.$Message.error('主机号不能为空')
        return
      }
      if (!this.batchSendCmd.cmd || this.batchSendCmd.cmd === '') {
        this.$Message.error('命令不能为空')
        return
      }
      this.batchSendCmd.terminalNums = this.terminalNums.split(',')
      console.log(this.batchSendCmd.terminalNums)
      // if (this.batchSendCmd.cmd.indexOf('99admin') != -1) {
      //   let that = this
      //   for (let i = 0; i < 3; i++) {
      //     // this.batchSendCmd.cmd.substring(',')
      //     if (i == 0) {
      //       setTimeout(function () {
      //         that.batchSendCmd.cmd = '99admin,admin,' + that.batchSendCmd.cmd.substring(that.batchSendCmd.cmd.length - 77)
      //         store.dispatch('NetCommandServ_BatchSendCmd', {
      //           params: that.batchSendCmd
      //         }).then(() => {
      //           that.$Message.success('发送成功')
      //         }).catch(err => {
      //           that.$Message.error(err)
      //         })
      //       }
      //
      //         , 1000
      //       )
      //     }
      //     if (i == 1) {
      //       setTimeout(function () {
      //         that.batchSendCmd.cmd = '99admin,JC336699,' + that.batchSendCmd.cmd.substring(that.batchSendCmd.cmd.length - 77)
      //         store.dispatch('NetCommandServ_BatchSendCmd', {
      //           params: that.batchSendCmd
      //         }).then(() => {
      //           that.$Message.success('发送成功')
      //         }).catch(err => {
      //           that.$Message.error(err)
      //         })
      //       }
      //         , 1000
      //       )
      //     }
      //     if (i == 2) {
      //       setTimeout(function () {
      //         that.batchSendCmd.cmd = '99admin,,' + that.batchSendCmd.cmd.substring(that.batchSendCmd.cmd.length - 77)
      //         store.dispatch('NetCommandServ_BatchSendCmd', {
      //           params: that.batchSendCmd
      //         }).then(() => {
      //           that.$Message.success('发送成功')
      //         }).catch(err => {
      //           that.$Message.error(err)
      //         })
      //       }
      //         , 1000
      //       )
      //     }
      //   }
      // } else {
        store.dispatch('NetCommandServ_BatchSendCmd', {
          params: this.batchSendCmd
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      // }
    },
    onExport () {
      // let sortParam = null;

      if (this.keywordFilter) {
        window.location.href = '/api/jt808device/getreport?keyword=' + this.keywordFilter
      } else {
        window.location.href = '/api/jt808device/getreport'
      }

      // if (this.sort !== null && this.sort !== undefined) {
      //     sortParam = genSortParam(this.sort.name, this.sort.asc);
      // } else {
      //     sortParam = genSortParam('id', false);
      // }

      // store.dispatch('Jt808DeviceServ_GetReport', {
      //     params: null,
      //     urlparams: {
      //         keyword: this.keywordFilter,
      //         sort: sortParam
      //     }
      // }).then(() => {
      //     this.list_loadding = false;
      // }).catch(err => {
      //     this.list_loadding = false;
      //     this.$Message.error(err);
      // });
    },
    onSetupRegistration () {
      store.dispatch('NetCommandServ_SetupRegistration', {
        params: this.setupRegistration
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onSendCommand () {
      store.dispatch('NetCommandServ_SendCommand', {
        params: this.sendCommand
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onSendHIKdataDownlinkTransmission () {
      this.dataDownlinkTransmission.transDataType = parseInt(248, 10)
      this.dataDownlinkTransmission.hex = true
      this.dataDownlinkTransmission.content = '01 64'

      store.dispatch('NetCommandServ_DataDownlinkTransmission', {
        params: this.dataDownlinkTransmission,
        urlparams: null
      }).then(() => {
        this.$Message.success('下发成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onSendHIKHardDisk () {
      this.dataDownlinkTransmission.transDataType = parseInt(247, 10)
      this.dataDownlinkTransmission.hex = true
      if (this.datacontent != 1) {
        this.dataDownlinkTransmission.content = '01 ' + this.datacontent
      }
      console.log(this.dataDownlinkTransmission.content)

      store.dispatch('NetCommandServ_DataDownlinkTransmission', {
        params: this.dataDownlinkTransmission,
        urlparams: null
      }).then(() => {
        this.$Message.success('下发成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onSendDrivingRecorderDataUploadChange () {
      store.dispatch('NetCommandServ_SetAcquisitionCommand', {
        params: this.drivingRecorderDataUpload,
        urlparams: null
      }).then(() => {
        this.$Message.success('下发成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },

    onFilterClick () {
      this.setPage(1)
    },
    onActiveBtnClick (userid) {
      this.$Modal.confirm({
        title: '激活角色',
        content: '<p>是否确认激活此角色</p>',
        onOk: () => {
          store.dispatch('Jt808DeviceServ_ActiveUser', { params: { userid: userid } }).then(() => {
            this.refreshPage(this.pageFilter)
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    onDeleteBtnClick (userid) {
      this.$Modal.confirm({
        title: '冻结角色',
        content: '<p>是否确认冻结此角色</p>',
        onOk: () => {
          store.dispatch('Jt808DeviceServ_DeleteObj', { params: { id: userid } }).then(() => {
            this.refreshPage(this.pageFilter)
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      this.pageIndex = page
      this.list_loadding = true

      let sortParam = null
      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null

      if (this.sort !== null && this.sort !== undefined) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      if (this.gpsEnableFilter) {
        qo1 = this.gpsEnableFilter
      }
      if (this.galileoEnableFilter) {
        qo2 = this.galileoEnableFilter
      }
      if (this.glonassEnableFilter) {
        qo3 = this.glonassEnableFilter
      }
      if (this.beidouEnableFilter) {
        qo4 = this.beidouEnableFilter
      }

      store.dispatch('Jt808DeviceServ_GetPage', {
        params: null,
        urlparams: {
          ps: this.pageFilter,
          p: page,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.list_loadding = false
      }).catch(err => {
        this.list_loadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onTimer () {
      let sortParam = null
      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null

      if (this.sort !== null && this.sort !== undefined) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      if (this.gpsEnableFilter) {
        qo1 = this.gpsEnableFilter
      }
      if (this.galileoEnableFilter) {
        qo2 = this.galileoEnableFilter
      }
      if (this.glonassEnableFilter) {
        qo3 = this.glonassEnableFilter
      }
      if (this.beidouEnableFilter) {
        qo4 = this.beidouEnableFilter
      }

      store.dispatch('Jt808DeviceServ_GetPage', {
        params: null,
        urlparams: {
          p: this.pageIndex,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        // this.list_loadding = false;
      }).catch(err => {
        // this.list_loadding = false;
        this.$Message.error(err)
      })
    }
  },
  computed: {
    computeCol () {
      let columns = this.columns
      columns = columns.filter(col => {
        for (var i = 0; i < this.columnsDisplay.length; i++) {
          if (this.columnsDisplay[i] === col.title) {
            return true
          }
        }
        return false
      })
      return columns
    },
    totalElements () {
      if (store.getters.get_Jt808Device_GetPageResult) {
        return store.getters.get_Jt808Device_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_Jt808Device_GetPageResult) {
        return store.getters.get_Jt808Device_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_Jt808Device_GetPageResult) {
        return store.getters.get_Jt808Device_GetPageResult.size
      } else {
        return 0
      }
    }

    // /**
    //  * 接收实时定位数据回调
    //  */
    // onRecvDymaicDataCallback (realtimeLocationFrame) {
    //   console.log(realtimeLocationFrame)
    //   this.$refs.Jt808MonitoringViewModalRef.putVehicleMarker(realtimeLocationFrame)
    // },
    //
    // /**
    //  * 取消监控车辆回调
    //  */
    // onCancelSubscribeDymaicDataCallback (vehicleInfos) {
    //   this.$refs.Jt808MonitoringViewModalRef.removeVehicleMarker(vehicleInfos)
    // },

  },
  mounted () {
    this.$nextTick(() => {
      this.columns.forEach(item => {
        this.columnHeaders.push(item.title)
        this.columnsDisplay.push(item.title)
      })
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)

      this.refreshTimer = setInterval(this.onTimer, 5000)

      // if (!this.vehicleDymaicManager) {
      //   console.log('创建vehicleDymaicManager')
      //   this.vehicleDymaicManager = new VehicleDymaicManager()
      //   this.vehicleDymaicManager.onRecvDymaicDataCallback = this.onRecvDymaicDataCallback
      //   this.vehicleDymaicManager.onCancelSubscribeDymaicDataCallback = this.onCancelSubscribeDymaicDataCallback
      // }
    })
  },
  destroyed () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  }
}
</script>

<style scoped>
</style>
